import { c as Qt, a as R, w as pt, g as ve, x as qn, O as ie, X as On, M as Fn, y as Vn, z as Bn, E as ft, H as Hn, J as Kn, K as jn, u as de, i as Yn, I as Gn, N as Dt, P as Zt, Q as en, L as Wn, R as Et, D as Un, p as Xn, q as Jn, r as Qn, s as Zn, t as ea, U as ta, B as Ft, m as na, e as aa, V as oa, W as Rt, Y as ra, Z as ia, _ as sa } from "./Dialog-snEJMtGv.js";
import { $ as Ld, a0 as Sd, a1 as Md, a2 as Pd, a3 as Dd, a4 as Ed, a5 as Rd, a6 as zd } from "./Dialog-snEJMtGv.js";
import { useRef as Y, useEffect as se, useMemo as De, forwardRef as T, useState as ue, Children as ca, useImperativeHandle as tn, useLayoutEffect as yt, useCallback as W, useId as Re, cloneElement as la, createElement as kn, useSyncExternalStore as da, Fragment as ua } from "react";
import { jsx as t, jsxs as k, Fragment as je } from "react/jsx-runtime";
import { flushSync as pa } from "react-dom";
const fa = [
  ["path", { d: "M12 19v3", key: "npa21l" }],
  ["path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33", key: "1gzdoj" }],
  ["path", { d: "M16.95 16.95A7 7 0 0 1 5 12v-2", key: "cqa7eg" }],
  ["path", { d: "M18.89 13.23A7 7 0 0 0 19 12v-2", key: "16hl24" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12", key: "r2i35w" }]
], ha = Qt("mic-off", fa);
const ba = [["path", { d: "M5 12h14", key: "1ays0h" }]], ma = Qt("minus", ba);
const ga = [
  [
    "path",
    {
      d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
      key: "9njp5v"
    }
  ]
], _a = Qt("phone", ga), hn = { user: null, assistant: null, assistantSpeaking: !1 }, Ke = {
  human: { strength: 1.4, motion: 1.2, density: 1.4, brightness: 1 },
  ai: { strength: 2.1, motion: 1.6, density: 1.5, brightness: 1.2 }
}, Ae = (o, e, n) => Math.max(e, Math.min(n, o)), ot = (o, e, n) => o + (e - o) * n;
function bn(o) {
  let e = 0, n = 0;
  for (const a of o) {
    const r = a / 255;
    e += r, r > n && (n = r);
  }
  return { average: o.length ? e / o.length : 0, peak: n };
}
class va {
  mode = "idle";
  micLevel = 0;
  aiActivity = 0;
  aiAudioLevel = 0;
  previousAiAudioLevel = 0;
  aiBreathPulse = 0;
  aiPulse = 0;
  update(e, n) {
    if (this.mode = e.assistantSpeaking ? "ai" : e.user ? "speech" : "idle", e.user) {
      const { average: a, peak: r } = bn(e.user);
      this.micLevel = ot(this.micLevel, Math.max(a * 1.8, r * 0.85), 0.18), this.aiActivity = Math.max(this.aiActivity, r * 0.45);
    } else
      this.micLevel *= 0.92;
    if (e.assistant) {
      const { average: a, peak: r } = bn(e.assistant);
      this.aiAudioLevel = ot(this.aiAudioLevel, Math.max(a * 1.7, r * 1.15), 0.24), this.aiActivity = Math.max(this.aiActivity, a * 1.7, r * 1.15);
    } else
      this.aiAudioLevel *= 0.9;
    if (this.mode === "ai") {
      const a = this.previousAiAudioLevel > 0.12 && this.aiAudioLevel < 0.07 ? 0.76 : 0;
      this.aiBreathPulse = Math.max(this.aiBreathPulse * 0.955, a), this.previousAiAudioLevel = this.aiAudioLevel, this.aiActivity *= 0.965;
      const r = 0.18 + Math.sin(n * 0.01) * 0.07;
      this.aiPulse = ot(this.aiPulse, Math.max(0.18, this.aiActivity + r), 0.16);
    } else
      this.aiActivity *= 0.9, this.aiPulse *= 0.88, this.aiAudioLevel *= 0.88, this.aiBreathPulse *= 0.88, this.previousAiAudioLevel = this.aiAudioLevel;
    return {
      base: Ae(this.micLevel * Ke.human.strength, 0, 1.4),
      ai: Ae(this.aiPulse * Ke.ai.strength, 0, 2.2),
      aiBreath: Ae(this.aiBreathPulse * Ke.ai.strength, 0, 1.5),
      demo: 0
    };
  }
}
function ya(o, e, n, a) {
  const r = e.x - o.x, i = e.y - o.y, s = Math.max(1, Math.hypot(r, i)), c = r / s, p = i / s, d = -p, g = c, f = n * o.motionSpeed + o.motionPhase, b = Math.sin(f) * 0.7 + Math.cos(f * 0.63 + 1.4) * 0.35, _ = Math.sin(f * 0.8 + s * 0.08) * 0.18;
  let h = r * 8e-4 + d * (0.045 + b * 0.03) + c * _ * 0.025, C = i * 8e-4 + g * (0.045 + b * 0.03) + p * _ * 0.025;
  const m = n * (7e-3 + a.base * 1e-3) + e.y * 0.014, l = a.base * Ke.human.motion, x = a.ai * Ke.ai.motion, y = a.aiBreath * Ke.ai.motion, E = Math.sin(m) * (0.08 + l * 0.16 + x * 0.24 + a.demo * 0.28), $ = Math.cos(m * 0.73 + e.x * 4e-3) * (0.025 + l * 0.06 + x * 0.1);
  h += E * 0.32, C += $;
  const q = n * 0.015 + o.seed * 0.11 + e.x * 0.012, z = Math.sin(q) * y, V = Math.cos(q * 0.71 + e.y * 8e-3) * y;
  h += d * z * 0.14 + c * V * 0.035, C += g * z * 0.14 + p * V * 0.035;
  const F = e.x * 0.024 - e.y * 0.017 - n * 6e-3, S = Math.cos(F) * (a.aiBreath * 0.85 + a.ai * 0.18) * Ke.ai.motion;
  h += 0.82 * S * 0.12, C -= 0.57 * S * 0.12;
  const M = f * 1.7 + e.x * 0.011, L = Math.sin(M) * (l * 0.08 + x * 0.18 + a.demo * 0.2);
  return h += d * L, C += g * L, { ax: h, ay: C };
}
const xa = "M309.959 16.0769C347.087 -5.35899 392.831 -5.35896 429.959 16.0769L679.919 160.39C717.047 181.826 739.919 221.442 739.919 264.314V552.942C739.919 595.814 717.047 635.429 679.919 656.865L429.959 801.179C392.831 822.615 347.087 822.615 309.959 801.179L60 656.865C22.8719 635.429 8.5819e-05 595.814 0 552.942V264.313C0.000173083 221.442 22.872 181.826 60 160.39L309.959 16.0769ZM249.035 119.18C220.454 119.18 194.044 134.428 179.753 159.18L58.8281 368.628C44.5375 393.38 44.5375 423.876 58.8281 448.628L179.753 658.075C194.043 682.827 220.453 698.075 249.034 698.075H490.884C519.465 698.075 545.875 682.827 560.166 658.075L681.091 448.628C695.381 423.876 695.381 393.38 681.091 368.628L560.166 159.18C545.875 134.428 519.465 119.18 490.884 119.18H249.035Z", $t = { width: 740, height: 818 }, mn = 560, Vt = 620, gn = 1.7, ht = 720, Ge = 800;
function wa(o, e, n) {
  const a = o.getContext("2d");
  if (!a) return null;
  const r = a;
  let i = [], s = [], c = null, p = null, d = null, g = 1, f = 0, b = 0;
  const _ = new va(), h = () => ({ x: 0, width: ht, cx: ht * 0.5 }), C = document.createElement("canvas");
  C.width = 256, C.height = 1;
  const m = C.getContext("2d", { willReadFrequently: !0 });
  if (!m) return null;
  const l = [];
  function x(S, M) {
    e = S, n = M;
    const L = m;
    L.globalAlpha = 1, L.fillStyle = n, L.fillRect(0, 0, 256, 1), L.fillStyle = e;
    for (let N = 0; N < 256; N++)
      L.globalAlpha = N / 255, L.fillRect(N, 0, 1, 1);
    const w = L.getImageData(0, 0, 256, 1).data;
    for (let N = 0; N < 256; N++) {
      const A = N * 4;
      l[N] = `rgb(${w[A]},${w[A + 1]},${w[A + 2]})`;
    }
  }
  x(e, n);
  function y(S, M) {
    const L = Math.floor((M - b) / g);
    if (!d || L < 0 || L >= d.length / 2) return !1;
    const w = (S - f) / g;
    return w >= d[L * 2] && w < d[L * 2 + 1];
  }
  function E(S, M = 0, L = 0) {
    const w = new Path2D();
    d = new Float64Array(S.height * 2), d.fill(1 / 0), g = 1, f = M, b = L;
    for (let N = 0; N < S.height; N++) {
      let A = -1, P = -1;
      for (let O = 0; O < S.width; O++)
        S.data[(N * S.width + O) * 4 + 3] > 18 && (A < 0 && (A = O), P = O);
      A >= 0 && (w.rect(A + M, N + L, P - A + 1, 1), d[N * 2] = A, d[N * 2 + 1] = P + 1);
    }
    p = w;
  }
  function $() {
    const S = new Path2D(xa), M = [], L = h(), w = L.cx, N = Ge * 0.5, A = Math.min(L.width * 0.88, mn), P = Math.min(Ge * 0.78, Vt), O = Math.min(
      A / $t.width,
      P / $t.height
    ), j = $t.width * O, Q = $t.height * O, H = w - j * 0.5, I = N - Q * 0.5, v = document.createElement("canvas");
    v.width = Math.max(1, Math.floor(j)), v.height = Math.max(1, Math.floor(Q));
    const K = v.getContext("2d", { willReadFrequently: !0 });
    if (!K) return M;
    K.clearRect(0, 0, v.width, v.height), K.save(), K.setTransform(O, 0, 0, O, -740 * 0.5 * O + v.width * 0.5, -818 * 0.5 * O + v.height * 0.5), K.fillStyle = e, K.fill(S), K.restore();
    const X = K.getImageData(0, 0, v.width, v.height);
    E(X, H, I);
    const oe = Math.floor(2200 * gn), ge = Math.max(1, Math.floor(Math.sqrt(v.width * v.height / Math.max(oe * 2, 1)))), _e = v.width * 0.5, he = v.height * 0.5, be = Math.hypot(_e, he) || 1;
    for (let U = 0; U < v.height; U += ge)
      for (let ce = 0; ce < v.width; ce += ge) {
        const me = (U * v.width + ce) * 4;
        if (X.data[me + 3] < 8) continue;
        const Ne = ce - _e, re = U - he, pe = Math.hypot(Ne, re) / be, Me = Ae(pe, 0, 1), Je = 0.06 + 0.94 * Math.pow(Me, 1.8);
        Math.random() > Je || M.push({
          x: H + ce,
          y: I + U,
          a: Math.atan2(re, Ne),
          baseR: 1,
          bias: Je,
          centerDist: Me
        });
      }
    return M;
  }
  function q(S) {
    if (!S.length) return S;
    let M = 1 / 0, L = 1 / 0, w = -1 / 0, N = -1 / 0;
    for (const K of S)
      K.x < M && (M = K.x), K.y < L && (L = K.y), K.x > w && (w = K.x), K.y > N && (N = K.y);
    const A = w - M, P = N - L, O = h(), j = Math.min(O.width * 0.88, mn), Q = Math.min(Ge * 0.78, Vt), H = Math.min(
      j / Math.max(1, A),
      Q / Math.max(1, P)
    ), I = O.x + (O.width - A * H) * 0.5, v = (Ge - P * H) * 0.5;
    if (p) {
      const K = new Path2D();
      K.addPath(p, new DOMMatrix([H, 0, 0, H, I - M * H, v - L * H])), p = K, f = f * H + I - M * H, b = b * H + v - L * H, g *= H;
    }
    return S.map((K) => ({
      x: (K.x - M) * H + I,
      y: (K.y - L) * H + v,
      a: K.a,
      baseR: K.baseR || 1,
      bias: K.bias,
      centerDist: K.centerDist
    }));
  }
  function z() {
    if (!s.length) {
      c = null;
      return;
    }
    let S = 1 / 0, M = 1 / 0, L = -1 / 0, w = -1 / 0;
    for (const N of s)
      N.x < S && (S = N.x), N.y < M && (M = N.y), N.x > L && (L = N.x), N.y > w && (w = N.y);
    c = { minX: S, minY: M, maxX: L, maxY: w, cx: (S + L) * 0.5, cy: (M + w) * 0.5 };
  }
  function V(S) {
    if (s = q(S), !s.length) return;
    const M = Math.max(800, Math.floor(s.length * gn)), L = [];
    for (let w = 0; w < M; w++) {
      const N = Math.floor(Math.random() * s.length), A = s[N];
      L.push({
        x: A.x,
        y: A.y,
        vx: 0,
        vy: 0,
        anchorIndex: N,
        seed: Math.random() * 1e3,
        motionPhase: Math.random() * Math.PI * 2,
        motionSpeed: 11e-4 + Math.random() * 18e-4,
        size: 0.45 + Math.pow(Math.random(), 2) * 2.35,
        sizePhase: Math.random() * Math.PI * 2,
        sizeSpeed: 5e-4 + Math.random() * 1e-3,
        centerDist: A.centerDist ?? 0.5,
        bias: A.bias ?? 0.5
      });
    }
    i = L, z();
  }
  function F(S, M, L) {
    if (!i.length || !s.length) return;
    const w = Math.min(h().width, Ge, Vt), N = _.mode === "ai" ? Ke.ai : Ke.human, A = Math.sin(S * 11e-4) * 0.6 + 0.9;
    r.save(), r.globalCompositeOperation = "lighter";
    for (const P of i) {
      const O = s[P.anchorIndex % s.length];
      if (L) {
        const Ze = ya(P, O, S, M);
        P.vx += Ze.ax, P.vy += Ze.ay;
        const Z = _.mode === "ai" ? 0.034 : 0.05;
        if (P.vx += (O.x - P.x) * Z * 12e-4, P.vy += (O.y - P.y) * Z * 12e-4, P.vx *= 0.92, P.vy *= 0.92, P.x += P.vx, P.y += P.vy, p && !y(P.x, P.y)) {
          let te = 0, Te = 1;
          for (let et = 0; et < 12; et++) {
            const Le = (te + Te) * 0.5;
            y(ot(O.x, P.x, Le), ot(O.y, P.y, Le)) ? te = Le : Te = Le;
          }
          P.x = ot(O.x, P.x, te * 0.98), P.y = ot(O.y, P.y, te * 0.98), P.vx *= 0.35, P.vy *= 0.35;
        }
      }
      const j = P.x - O.x, Q = P.y - O.y, H = Math.hypot(j, Q), I = Ae(1 - H / (w * 0.22), 0, 1), v = 0.55 + 0.45 * Math.sin(S * 14e-4 + P.seed * 0.7), K = Ae(M.ai * 0.6 + M.base * 0.2, 0, 1), X = 0.42, oe = c ? c.cx : ht * 0.5, ge = c ? c.cy : Ge * 0.5, _e = c ? Math.min(c.maxX - c.minX, c.maxY - c.minY) * 0.5 : w * 0.42, he = Math.max(1, _e * X), be = Math.hypot(P.x - oe, P.y - ge), U = Ae(be / he, 0, 1), ce = Ae((U - 0.35) / 0.65, 0, 1), me = 0.04 + 0.96 * ce * ce * (3 - 2 * ce), Ne = O.x * 0.024 - O.y * 0.017 - S * 6e-3, re = Math.pow((Math.sin(Ne) + 1) * 0.5, 6), pe = _.mode === "ai" ? Ae(M.aiBreath * 0.9 + M.ai * 0.22, 0, 1) : 0, Me = 1 - pe * 0.38 + re * pe * 0.92;
      if (P.seed * 0.61803398875 % 1 > Ae(me * N.density * Me, 0, 1)) continue;
      const ke = 1 + 0.22 * Math.sin(S * P.sizeSpeed + P.sizePhase) + 0.1 * Math.sin(S * P.sizeSpeed * 1.73 + P.sizePhase * 2), $e = P.size * ke * (0.92 + K * 0.18 + I * 0.22 + A * 0.08), ze = re * pe, Qe = Math.round(Ae(190 - H * 0.08 + K * 35 + v * 16 + ze * 28 + (N.brightness - 1) * 35, 120, 255)), Ye = Ae((0.18 + (1 - H / (w * 0.18)) * 0.45 + K * 0.22 + ze * 0.16) * N.brightness, 0.08, 0.9);
      r.fillStyle = l[Qe], r.globalAlpha = Ye, r.beginPath(), r.arc(P.x, P.y, $e, 0, Math.PI * 2), r.fill();
    }
    r.restore();
  }
  return V($()), {
    setColors: x,
    resize(S, M, L) {
      const w = Ae(L, 1, 2);
      o.width = Math.max(1, Math.floor(S * w)), o.height = Math.max(1, Math.floor(M * w));
      const N = Math.min(S / ht, M / Ge) * w;
      r.setTransform(N, 0, 0, N, (o.width - ht * N) * 0.5, (o.height - Ge * N) * 0.5);
    },
    draw(S, M, L = !0) {
      r.save(), r.resetTransform(), r.clearRect(0, 0, o.width, o.height), r.restore(), F(S, _.update(M, S), L);
    }
  };
}
const Na = "_root_1n9iv_2", ka = {
  root: Na
};
function $a({ readAudio: o, active: e = !0, className: n, ...a }) {
  const r = Y(null), i = Y(o);
  return se(() => {
    i.current = o;
  }, [o]), se(() => {
    const s = r.current;
    if (!s) return;
    const c = window.matchMedia("(prefers-reduced-motion: reduce)"), p = getComputedStyle(s);
    let d = p.color, g = p.getPropertyValue("--openbitfun-color-content-on-light").trim();
    const f = wa(
      s,
      d,
      g
    );
    if (!f) return;
    let b = 0, _ = 0, h = !0, C = 0, m = 0;
    const l = 1e3 / 60, x = () => e && h && !document.hidden && !c.matches && C > 0 && m > 0, y = (F) => {
      if (b = 0, !x()) return;
      const S = F - _;
      S >= l - 0.5 && (_ = F - S % l, f.draw(F, i.current?.() ?? hn)), b = requestAnimationFrame(y);
    }, E = () => {
      cancelAnimationFrame(b), b = 0, _ = 0, !(!C || !m) && (x() ? b = requestAnimationFrame(y) : f.draw(0, hn, !1));
    }, $ = new ResizeObserver(([F]) => {
      F && (C = F.contentRect.width, m = F.contentRect.height, f.resize(C, m, window.devicePixelRatio || 1), E());
    }), q = new IntersectionObserver(([F]) => {
      F && (h = F.isIntersecting, E());
    }), z = new MutationObserver(() => {
      const F = getComputedStyle(s), S = F.color, M = F.getPropertyValue("--openbitfun-color-content-on-light").trim();
      d === S && g === M || (d = S, g = M, f.setColors(d, g), E());
    });
    for (let F = s; F; F = F.parentElement)
      z.observe(F, { attributes: !0, attributeFilter: ["style", "class", "data-color-scheme", "data-contrast"] });
    const V = () => {
      f.resize(C, m, window.devicePixelRatio || 1), E();
    };
    return $.observe(s), q.observe(s), c.addEventListener("change", E), document.addEventListener("visibilitychange", E), window.addEventListener("resize", V), () => {
      cancelAnimationFrame(b), $.disconnect(), q.disconnect(), z.disconnect(), c.removeEventListener("change", E), document.removeEventListener("visibilitychange", E), window.removeEventListener("resize", V);
    };
  }, [e]), /* @__PURE__ */ t(
    "canvas",
    {
      ...a,
      ref: r,
      className: R(ka.root, n),
      "data-openbitfun-component": "voice-particle-logo",
      "data-openbitfun-part": "root",
      "aria-hidden": "true"
    }
  );
}
const Ca = "_root_1gj8z_2", Aa = "_header_1gj8z_32", Ia = "_title_1gj8z_40", La = "_back_1gj8z_52", Sa = "_close_1gj8z_53", Ma = "_visualizer_1gj8z_70", Pa = "_conversation_1gj8z_78", Da = "_user_1gj8z_92", Ea = "_assistant_1gj8z_103", Ra = "_status_1gj8z_105", za = "_controls_1gj8z_109", Ta = "_control_1gj8z_109", ye = {
  root: Ca,
  header: Aa,
  title: Ia,
  back: La,
  close: Sa,
  visualizer: Ma,
  conversation: Pa,
  user: Da,
  assistant: Ea,
  status: Ra,
  controls: za,
  control: Ta
};
function Cl({
  title: o,
  labels: e,
  phase: n = "live",
  muted: a = !1,
  userTranscript: r,
  assistantTranscript: i,
  status: s,
  readAudio: c,
  onBack: p,
  onClose: d,
  onToggleMute: g,
  onOpenSettings: f,
  onEnd: b,
  className: _,
  ...h
}) {
  const C = Y(null), m = Y(!0), l = n === "connecting" || n === "ending";
  return se(() => {
    const x = C.current;
    x && m.current && (x.scrollTop = x.scrollHeight);
  }, [r, i, s]), /* @__PURE__ */ k(
    "section",
    {
      ...h,
      className: R(ye.root, _),
      "aria-label": o,
      "data-openbitfun-component": "voice-call-panel",
      "data-openbitfun-part": "root",
      "data-openbitfun-phase": n,
      children: [
        /* @__PURE__ */ k("header", { className: ye.header, "data-openbitfun-part": "header", children: [
          /* @__PURE__ */ t(pt, { content: e.back, children: /* @__PURE__ */ t(
            ve,
            {
              className: ye.back,
              shape: "circle",
              "aria-label": e.back,
              onClick: p,
              disabled: n === "ending",
              icon: /* @__PURE__ */ t(qn, { size: 20 })
            }
          ) }),
          /* @__PURE__ */ t("h2", { className: ye.title, "data-openbitfun-part": "title", children: /* @__PURE__ */ t(ie, { children: o }) }),
          /* @__PURE__ */ t(pt, { content: e.close, children: /* @__PURE__ */ t(
            ve,
            {
              className: ye.close,
              shape: "circle",
              "aria-label": e.close,
              onClick: d,
              icon: /* @__PURE__ */ t(On, { size: 20 })
            }
          ) })
        ] }),
        /* @__PURE__ */ t("div", { className: ye.visualizer, "data-openbitfun-part": "visualizer", children: /* @__PURE__ */ t($a, { readAudio: c, active: n === "live" || n === "connecting" }) }),
        /* @__PURE__ */ k(
          "div",
          {
            ref: C,
            className: ye.conversation,
            "data-openbitfun-part": "conversation",
            "aria-live": "polite",
            "aria-relevant": "additions text",
            onScroll: () => {
              const x = C.current;
              x && (m.current = x.scrollHeight - x.clientHeight - x.scrollTop < 24);
            },
            children: [
              r && /* @__PURE__ */ t("div", { className: ye.user, "data-openbitfun-part": "userTranscript", children: r }),
              i && /* @__PURE__ */ t("div", { className: ye.assistant, "data-openbitfun-part": "assistantTranscript", children: i }),
              s && /* @__PURE__ */ t("div", { className: ye.status, role: "status", "data-openbitfun-part": "status", children: s })
            ]
          }
        ),
        /* @__PURE__ */ k("footer", { className: ye.controls, "data-openbitfun-part": "controls", children: [
          /* @__PURE__ */ t(pt, { content: a ? e.unmute : e.mute, children: /* @__PURE__ */ t(
            ve,
            {
              className: ye.control,
              shape: "circle",
              "aria-label": a ? e.unmute : e.mute,
              "aria-pressed": a,
              disabled: l,
              onClick: g,
              icon: a ? /* @__PURE__ */ t(ha, { size: 28 }) : /* @__PURE__ */ t(Fn, { size: 28 })
            }
          ) }),
          /* @__PURE__ */ t(pt, { content: e.settings, children: /* @__PURE__ */ t(
            ve,
            {
              className: ye.control,
              shape: "circle",
              "aria-label": e.settings,
              onClick: f,
              icon: /* @__PURE__ */ t(Vn, { size: 28 })
            }
          ) }),
          /* @__PURE__ */ t(pt, { content: e.end, children: /* @__PURE__ */ t(
            ve,
            {
              className: ye.control,
              shape: "circle",
              "aria-label": e.end,
              disabled: n === "ending",
              onClick: b,
              icon: /* @__PURE__ */ t(_a, { size: 28 })
            }
          ) })
        ] })
      ]
    }
  );
}
function Al({
  children: o,
  colorScheme: e = ft.colorScheme,
  contrast: n = ft.contrast,
  density: a = ft.density,
  locale: r = ft.locale,
  messages: i,
  portalHost: s,
  tooltipDelay: c = ft.tooltipDelay
}) {
  const p = De(() => new Bn(), []), d = De(() => ({
    colorScheme: e,
    contrast: n,
    density: a,
    locale: r,
    messages: { ...Hn, ...i },
    portalHost: s,
    tooltipDelay: c
  }), [e, n, a, r, i, s, c]);
  return /* @__PURE__ */ t(Kn.Provider, { value: d, children: /* @__PURE__ */ t(jn.Provider, { value: p, children: o }) });
}
const qa = "_root_10071_2", Oa = "_trigger_10071_3", Fa = "_leading_10071_4", Va = "_content_10071_5", Ba = "_title_10071_6", Ha = "_description_10071_7", Ka = "_actions_10071_8", tt = {
  root: qa,
  trigger: Oa,
  leading: Fa,
  content: Va,
  title: Ba,
  description: Ha,
  actions: Ka
}, Il = T(
  function({
    actions: e = [],
    children: n,
    body: a,
    triggerClassName: r,
    className: i,
    description: s,
    disabled: c = !1,
    leading: p,
    selected: d = !1,
    size: g = "sm",
    type: f = "button",
    ...b
  }, _) {
    return /* @__PURE__ */ k(
      "span",
      {
        className: R(tt.root, i),
        "data-openbitfun-component": "action-card",
        "data-disabled": c ? "true" : "false",
        "data-has-actions": e.length > 0 ? "true" : "false",
        "data-selected": d ? "true" : "false",
        "data-size": g,
        children: [
          /* @__PURE__ */ k(
            "button",
            {
              "data-overflow-trigger": !0,
              ...b,
              className: R(tt.trigger, r),
              "data-openbitfun-part": "trigger",
              disabled: c,
              ref: _,
              type: f,
              children: [
                p != null && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: tt.leading, "data-openbitfun-part": "leading", children: p }),
                a !== void 0 ? a : /* @__PURE__ */ k("span", { className: tt.content, "data-openbitfun-part": "content", children: [
                  /* @__PURE__ */ t(ie, { className: tt.title, "data-openbitfun-part": "title", children: n }),
                  s != null && /* @__PURE__ */ t(ie, { className: tt.description, "data-openbitfun-part": "description", children: s })
                ] })
              ]
            }
          ),
          e.length > 0 && /* @__PURE__ */ t("span", { className: tt.actions, "data-openbitfun-part": "actions", children: e.map((h) => /* @__PURE__ */ t(
            ve,
            {
              "aria-label": h.label,
              disabled: c || h.disabled,
              icon: h.icon,
              onClick: h.onClick,
              size: "xs",
              tone: h.tone,
              variant: "quiet"
            },
            h.id
          )) })
        ]
      }
    );
  }
), ja = "_root_1ojnc_2", Ya = "_trigger_1ojnc_18", Ga = "_label_1ojnc_27", Wa = "_leading_1ojnc_77", Ua = "_staticLabel_1ojnc_106", Xa = "_metadata_1ojnc_111", Ja = "_shortcut_1ojnc_112", Qa = "_actions_1ojnc_113", Be = {
  root: ja,
  trigger: Ya,
  label: Ga,
  leading: Wa,
  staticLabel: Ua,
  metadata: Xa,
  shortcut: Ja,
  actions: Qa
}, $n = T(function({
  actions: e = [],
  actionContent: n,
  triggerClassName: a,
  children: r,
  className: i,
  disabled: s,
  leading: c,
  labelBehavior: p = "overflow",
  metadata: d,
  reserveLeadingSpace: g = !1,
  shortcut: f,
  tone: b = "neutral",
  type: _ = "button",
  ...h
}, C) {
  const m = g || c != null;
  return /* @__PURE__ */ k(
    "span",
    {
      className: R(Be.root, i),
      "data-openbitfun-component": "action-item",
      "data-openbitfun-tone": b,
      "data-disabled": s ? "true" : "false",
      children: [
        /* @__PURE__ */ k(
          "button",
          {
            "data-overflow-trigger": !0,
            ...h,
            className: R(Be.trigger, a),
            "data-openbitfun-part": "trigger",
            disabled: s,
            ref: C,
            type: _,
            children: [
              m && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Be.leading, "data-openbitfun-part": "leading", children: c }),
              p === "static" ? /* @__PURE__ */ t("span", { className: R(Be.label, Be.staticLabel), "data-openbitfun-part": "label", children: r }) : /* @__PURE__ */ t(ie, { className: Be.label, "data-openbitfun-part": "label", children: r }),
              d != null && /* @__PURE__ */ t("span", { className: Be.metadata, "data-openbitfun-part": "metadata", children: d }),
              f != null && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Be.shortcut, "data-openbitfun-part": "shortcut", children: f })
            ]
          }
        ),
        (e.length > 0 || n != null) && /* @__PURE__ */ k("span", { className: Be.actions, "data-openbitfun-part": "actions", children: [
          n,
          e.map((l) => /* @__PURE__ */ t(
            ve,
            {
              "aria-label": l.label,
              "aria-checked": l.role === "menuitemcheckbox" || l.role === "menuitemradio" ? l.checked : void 0,
              "data-testid": l.testId,
              disabled: s || l.disabled,
              icon: l.icon,
              onClick: l.onClick,
              role: l.role,
              size: "sm",
              tone: l.tone,
              variant: "quiet",
              ...l.testAttributes
            },
            l.id
          ))
        ] })
      ]
    }
  );
}), Za = "_root_1wpg0_2", eo = "_trigger_1wpg0_3", to = "_body_1wpg0_4", no = "_leading_1wpg0_5", ao = "_content_1wpg0_6", oo = "_label_1wpg0_7", ro = "_description_1wpg0_8", io = "_metadata_1wpg0_9", so = "_actions_1wpg0_10", co = "_divider_1wpg0_11", lo = "_detail_1wpg0_12", uo = "_changeCount_1wpg0_13", po = "_additions_1wpg0_14", fo = "_deletions_1wpg0_15", xe = {
  root: Za,
  trigger: eo,
  body: to,
  leading: no,
  content: ao,
  label: oo,
  description: ro,
  metadata: io,
  actions: so,
  divider: co,
  detail: lo,
  changeCount: uo,
  additions: po,
  deletions: fo
};
function ho({
  children: o,
  label: e,
  leading: n
}) {
  return /* @__PURE__ */ k(je, { children: [
    n != null && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: xe.leading, "data-openbitfun-part": "leading", children: n }),
    /* @__PURE__ */ k("span", { className: xe.content, "data-openbitfun-part": "content", children: [
      e != null && /* @__PURE__ */ t(ie, { className: xe.label, "data-openbitfun-part": "label", children: e }),
      /* @__PURE__ */ t(ie, { className: xe.description, "data-openbitfun-part": "description", children: o })
    ] })
  ] });
}
const Ll = T(
  function({
    actions: e = [],
    appearance: n = "inline",
    children: a,
    className: r,
    detail: i,
    disabled: s = !1,
    label: c,
    leading: p,
    metadata: d,
    onActivate: g,
    ...f
  }, b) {
    const _ = /* @__PURE__ */ t(ho, { label: c, leading: p, children: a }), h = i != null;
    return /* @__PURE__ */ k(
      "span",
      {
        ...f,
        "aria-disabled": s || void 0,
        className: R(xe.root, r),
        "data-appearance": n,
        "data-openbitfun-component": "activity-item",
        "data-disabled": s ? "true" : "false",
        "data-has-detail": h ? "true" : "false",
        ref: b,
        children: [
          g ? /* @__PURE__ */ t(
            "button",
            {
              "data-overflow-trigger": !0,
              className: xe.trigger,
              "data-openbitfun-part": "trigger",
              disabled: s,
              onClick: g,
              type: "button",
              children: _
            }
          ) : /* @__PURE__ */ t("span", { className: xe.body, "data-openbitfun-part": "body", children: _ }),
          d != null && /* @__PURE__ */ t("span", { className: xe.metadata, "data-openbitfun-part": "metadata", children: d }),
          e.length > 0 && /* @__PURE__ */ k(je, { children: [
            /* @__PURE__ */ t("span", { "aria-hidden": "true", className: xe.divider, "data-openbitfun-part": "divider" }),
            /* @__PURE__ */ t("span", { className: xe.actions, "data-openbitfun-part": "actions", children: e.map((C) => /* @__PURE__ */ t(
              ve,
              {
                "aria-label": C.label,
                disabled: s || C.disabled,
                icon: C.icon,
                onClick: C.onClick,
                size: "xs",
                tone: C.tone,
                variant: "quiet"
              },
              C.id
            )) })
          ] }),
          h && /* @__PURE__ */ t("span", { className: xe.detail, "data-openbitfun-part": "detail", children: i })
        ]
      }
    );
  }
), Sl = T(
  function({ additions: e = 0, className: n, deletions: a = 0, ...r }, i) {
    return /* @__PURE__ */ k(
      "span",
      {
        ...r,
        className: R(xe.changeCount, n),
        "data-openbitfun-component": "change-count",
        ref: i,
        children: [
          /* @__PURE__ */ k("span", { className: xe.additions, "data-openbitfun-part": "additions", children: [
            "+",
            Math.abs(e)
          ] }),
          /* @__PURE__ */ k("span", { className: xe.deletions, "data-openbitfun-part": "deletions", children: [
            "-",
            Math.abs(a)
          ] })
        ]
      }
    );
  }
), bo = "_root_71hn3_2", mo = "_icon_71hn3_6", go = "_content_71hn3_7", _o = "_title_71hn3_8", vo = "_message_71hn3_9", yo = "_description_71hn3_10", xo = "_close_71hn3_11", nt = {
  root: bo,
  icon: mo,
  content: go,
  title: _o,
  message: vo,
  description: yo,
  close: xo
}, wo = {
  error: "info",
  info: "info",
  success: "check-circle",
  warning: "info"
}, Ml = T(function({
  "aria-live": e,
  className: n,
  closable: a = !1,
  closeLabel: r = "Close",
  description: i,
  message: s,
  onClose: c,
  role: p,
  showIcon: d = !0,
  title: g,
  tone: f = "info",
  ...b
}, _) {
  const [h, C] = ue(!0);
  return h ? /* @__PURE__ */ k(
    "div",
    {
      ...b,
      "aria-live": e ?? (p === "status" ? "polite" : p === "alert" || f === "error" ? "assertive" : "polite"),
      className: R(nt.root, n),
      "data-openbitfun-component": "alert",
      "data-openbitfun-tone": f,
      ref: _,
      role: p ?? "alert",
      children: [
        d && /* @__PURE__ */ t("span", { className: nt.icon, "data-openbitfun-part": "icon", children: /* @__PURE__ */ t(de, { name: wo[f], size: "sm" }) }),
        /* @__PURE__ */ k("span", { className: nt.content, "data-openbitfun-part": "content", children: [
          g !== void 0 && /* @__PURE__ */ t("span", { className: nt.title, "data-openbitfun-part": "title", children: g }),
          /* @__PURE__ */ t("span", { className: nt.message, "data-openbitfun-part": "message", children: s }),
          i !== void 0 && /* @__PURE__ */ t("span", { className: nt.description, "data-openbitfun-part": "description", children: i })
        ] }),
        a && /* @__PURE__ */ t(
          ve,
          {
            "aria-label": r,
            className: nt.close,
            icon: /* @__PURE__ */ t(de, { name: "xmark" }),
            onClick: () => {
              C(!1), c?.();
            },
            size: "xs",
            variant: "quiet"
          }
        )
      ]
    }
  ) : null;
}), No = "_root_701to_2", ko = "_image_701to_6", $o = "_content_701to_7", Co = "_group_701to_9", vt = {
  root: No,
  image: ko,
  content: $o,
  group: Co
};
function Ao({ alt: o = "", children: e, className: n, icon: a, onError: r, shape: i = "circle", size: s = "md", src: c, ...p }) {
  const [d, g] = ue(!1);
  return /* @__PURE__ */ t("span", { ...p, className: R(vt.root, n), "data-openbitfun-component": "avatar", "data-openbitfun-shape": i, "data-size": s, children: c && !d ? /* @__PURE__ */ t("img", { alt: o, className: vt.image, "data-openbitfun-part": "image", onError: () => {
    g(!0), r?.();
  }, src: c }) : a !== void 0 ? /* @__PURE__ */ t("span", { className: vt.content, "data-openbitfun-part": "icon", children: a }) : /* @__PURE__ */ t("span", { className: vt.content, "data-openbitfun-part": "text", children: e }) });
}
function Pl({ children: o, className: e, maxCount: n = 5, ...a }) {
  const r = ca.toArray(o), i = n > 0 ? r.slice(0, n) : r, s = Math.max(0, r.length - i.length);
  return /* @__PURE__ */ k("div", { ...a, className: R(vt.group, e), "data-openbitfun-component": "avatar-group", children: [
    i,
    s > 0 && /* @__PURE__ */ k(Ao, { "aria-label": `${s} more`, children: [
      "+",
      s
    ] })
  ] });
}
const Io = "_root_1mqr3_2", Lo = "_control_1mqr3_22", So = "_input_1mqr3_31", Mo = "_box_1mqr3_53", Po = "_icon_1mqr3_82", Do = "_content_1mqr3_94", Eo = "_label_1mqr3_95", Ro = "_description_1mqr3_96", He = {
  root: Io,
  control: Lo,
  input: So,
  box: Mo,
  icon: Po,
  content: Do,
  label: Eo,
  description: Ro
}, Dl = T(function({
  appearance: e = "custom",
  checked: n,
  children: a,
  className: r,
  defaultChecked: i,
  description: s,
  disabled: c = !1,
  indeterminate: p = !1,
  invalid: d = !1,
  label: g,
  onChange: f,
  onCheckedChange: b,
  size: _ = "md",
  ...h
}, C) {
  const m = Y(null);
  tn(C, () => m.current), se(() => {
    m.current && (m.current.indeterminate = p);
  }, [p]);
  const l = g !== void 0 || s !== void 0 || a !== void 0;
  return /* @__PURE__ */ k(
    "label",
    {
      className: R(He.root, r),
      "data-openbitfun-component": "checkbox",
      "data-appearance": e,
      "data-disabled": c ? "true" : "false",
      "data-indeterminate": p ? "true" : "false",
      "data-invalid": d ? "true" : "false",
      "data-size": _,
      children: [
        /* @__PURE__ */ k("span", { className: He.control, "data-openbitfun-part": "control", children: [
          /* @__PURE__ */ t(
            "input",
            {
              ...h,
              "aria-invalid": d || void 0,
              checked: n,
              className: He.input,
              defaultChecked: i,
              "data-openbitfun-part": "input",
              disabled: c,
              onChange: (x) => {
                f?.(x), x.defaultPrevented || b?.(x.currentTarget.checked);
              },
              ref: m,
              type: "checkbox"
            }
          ),
          e === "custom" && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: He.box, "data-openbitfun-part": "box", children: /* @__PURE__ */ t(je, { children: p ? /* @__PURE__ */ t(ma, { className: He.icon, "aria-hidden": "true" }) : /* @__PURE__ */ t(Yn, { className: He.icon, "aria-hidden": "true" }) }) })
        ] }),
        l && /* @__PURE__ */ k("span", { className: He.content, "data-openbitfun-part": "content", children: [
          g !== void 0 && /* @__PURE__ */ t("span", { className: He.label, children: g }),
          s !== void 0 && /* @__PURE__ */ t("span", { className: He.description, children: s }),
          a
        ] })
      ]
    }
  );
}), zo = "_root_ko9wb_2", To = "_header_ko9wb_3", qo = "_leading_ko9wb_4", Oo = "_headerContent_ko9wb_5", Fo = "_title_ko9wb_6", Vo = "_description_ko9wb_7", Bo = "_actions_ko9wb_8", Ho = "_body_ko9wb_9", Ko = "_media_ko9wb_10", jo = "_footer_ko9wb_11", Oe = {
  root: zo,
  header: To,
  leading: qo,
  headerContent: Oo,
  title: Fo,
  description: Vo,
  actions: Bo,
  body: Ho,
  media: Ko,
  footer: jo
}, El = T(function({
  appearance: e = "subtle",
  children: n,
  className: a,
  clip: r = !1,
  gap: i = "none",
  padding: s = "none",
  radius: c = "md",
  ...p
}, d) {
  return /* @__PURE__ */ t(
    "div",
    {
      ...p,
      className: R(Oe.root, a),
      "data-appearance": e,
      "data-openbitfun-component": "card",
      "data-clip": r ? "true" : "false",
      "data-gap": i,
      "data-padding": s,
      "data-radius": c,
      ref: d,
      children: n
    }
  );
}), Rl = T(
  function({
    actions: e,
    align: n = "start",
    children: a,
    className: r,
    contentAlign: i = "start",
    description: s,
    leading: c,
    padding: p = "none",
    title: d,
    ...g
  }, f) {
    return /* @__PURE__ */ k(
      "div",
      {
        ...g,
        className: R(Oe.header, r),
        "data-align": n,
        "data-openbitfun-part": "header",
        "data-content-align": i,
        "data-padding": p,
        ref: f,
        children: [
          c != null && /* @__PURE__ */ t("div", { className: Oe.leading, "data-openbitfun-part": "leading", children: c }),
          /* @__PURE__ */ k(
            "div",
            {
              className: Oe.headerContent,
              "data-align": i,
              "data-openbitfun-part": "header-content",
              children: [
                d != null && /* @__PURE__ */ t("div", { className: Oe.title, "data-openbitfun-part": "title", children: d }),
                s != null && /* @__PURE__ */ t("div", { className: Oe.description, "data-openbitfun-part": "description", children: s }),
                a
              ]
            }
          ),
          e != null && /* @__PURE__ */ t("div", { className: Oe.actions, "data-openbitfun-part": "actions", children: e })
        ]
      }
    );
  }
), zl = T(
  function({ align: e = "stretch", children: n, className: a, padding: r = "none", ...i }, s) {
    return /* @__PURE__ */ t(
      "div",
      {
        ...i,
        className: R(Oe.body, a),
        "data-align": e,
        "data-openbitfun-part": "body",
        "data-padding": r,
        ref: s,
        children: n
      }
    );
  }
), Tl = T(
  function({ children: e, className: n, ...a }, r) {
    return /* @__PURE__ */ t(
      "div",
      {
        ...a,
        className: R(Oe.media, n),
        "data-openbitfun-part": "media",
        ref: r,
        children: e
      }
    );
  }
), ql = T(
  function({
    align: e = "end",
    children: n,
    className: a,
    padding: r = "none",
    ...i
  }, s) {
    return /* @__PURE__ */ t(
      "div",
      {
        ...i,
        className: R(Oe.footer, a),
        "data-align": e,
        "data-openbitfun-part": "footer",
        "data-padding": r,
        ref: s,
        children: n
      }
    );
  }
), Yo = "_root_p6vm2_2", Go = "_context_p6vm2_3", Wo = "_surface_p6vm2_4", Uo = "_editor_p6vm2_5", Xo = "_toolbar_p6vm2_6", Jo = "_bar_p6vm2_7", Qo = "_barLeading_p6vm2_8", Zo = "_barContent_p6vm2_9", er = "_barTrailing_p6vm2_10", tr = "_divider_p6vm2_11", Fe = {
  root: Yo,
  context: Go,
  surface: Wo,
  editor: Uo,
  toolbar: Xo,
  bar: Jo,
  barLeading: Qo,
  barContent: Zo,
  barTrailing: er,
  divider: tr
}, Ol = T(
  function({
    "aria-disabled": e,
    "aria-invalid": n,
    children: a,
    className: r,
    contextBar: i,
    disabled: s = !1,
    invalid: c = !1,
    toolbar: p,
    ...d
  }, g) {
    const f = s || e === !0 || e === "true", b = c || n === !0 || n === "true";
    return /* @__PURE__ */ k(
      "fieldset",
      {
        ...d,
        "aria-disabled": f || void 0,
        "aria-invalid": b || void 0,
        className: R(Fe.root, r),
        "data-openbitfun-component": "composer",
        "data-disabled": f ? "true" : "false",
        "data-has-context": i != null ? "true" : "false",
        "data-invalid": b ? "true" : "false",
        disabled: f,
        ref: g,
        children: [
          i != null && /* @__PURE__ */ t("div", { className: Fe.context, "data-openbitfun-part": "context", children: i }),
          /* @__PURE__ */ k("div", { className: Fe.surface, "data-openbitfun-part": "surface", children: [
            /* @__PURE__ */ t("div", { className: Fe.editor, "data-openbitfun-part": "editor", children: a }),
            p != null && /* @__PURE__ */ t("div", { className: Fe.toolbar, "data-openbitfun-part": "toolbar", children: p })
          ] })
        ]
      }
    );
  }
);
function Cn({
  children: o,
  className: e,
  leading: n,
  trailing: a,
  ...r
}, i, s) {
  return /* @__PURE__ */ k(
    "div",
    {
      ...r,
      className: R(Fe.bar, e),
      "data-openbitfun-part": s,
      ref: i,
      children: [
        n != null && /* @__PURE__ */ t("div", { className: Fe.barLeading, "data-openbitfun-part": "bar-leading", children: n }),
        o != null && /* @__PURE__ */ t("div", { className: Fe.barContent, "data-openbitfun-part": "bar-content", children: o }),
        a != null && /* @__PURE__ */ t("div", { className: Fe.barTrailing, "data-openbitfun-part": "bar-trailing", children: a })
      ]
    }
  );
}
const Fl = T(
  function(e, n) {
    return Cn(e, n, "context-bar");
  }
), Vl = T(
  function(e, n) {
    return Cn(e, n, "toolbar-bar");
  }
), Bl = T(
  function({ className: e, ...n }, a) {
    return /* @__PURE__ */ t(
      "span",
      {
        ...n,
        "aria-hidden": "true",
        className: R(Fe.divider, e),
        "data-openbitfun-part": "divider",
        ref: a
      }
    );
  }
), nr = typeof window > "u" ? se : yt;
function nn({ open: o, anchorRef: e, layerRef: n, placement: a = "bottom", matchWidth: r = !1, overlapAnchor: i = !1, revision: s, point: c }) {
  const [p, d] = ue(null);
  return nr(() => {
    if (!o) {
      d(null);
      return;
    }
    const g = e.current, f = n.current, b = f?.ownerDocument.defaultView;
    if (!f || !b || !g && !c) return;
    const _ = () => {
      const m = c ? 0 : 4, l = c ? { left: c.x, right: c.x, top: c.y, bottom: c.y, width: 0, height: 0 } : g.getBoundingClientRect(), x = b.visualViewport, y = x?.offsetLeft ?? 0, E = x?.offsetTop ?? 0, $ = x?.width ?? b.innerWidth, q = x?.height ?? b.innerHeight, z = r ? Math.min(l.width, $ - 16) : void 0;
      f.style.maxWidth = `${Math.max(0, $ - 16)}px`, z !== void 0 && (f.style.width = `${z}px`);
      const V = f.getBoundingClientRect(), F = a === "left" || a === "right", S = F ? l.left - y : l.top - E, M = F ? y + $ - l.right : E + q - l.bottom, L = F ? l.width : l.height, w = i ? L : -m, N = S + w, A = M + w, P = (F ? V.width : V.height) + 8, j = a === "top" || a === "left" ? N >= P || N > A : A < P && N > A, Q = F ? j ? "left" : "right" : j ? "top" : "bottom", H = F ? q - 16 : Math.max(0, (j ? N : A) - 8), I = Math.min(V.height, H), v = F ? i ? j ? l.right - V.width : l.left : j ? l.left - V.width - m : l.right + m : l.left, K = F ? l.top : i ? j ? l.bottom - I : l.top : j ? l.top - I - m : l.bottom + m, X = {
        position: "fixed",
        width: z,
        maxWidth: $ - 16,
        maxHeight: H,
        left: Math.max(y + 8, Math.min(v, y + $ - V.width - 8)),
        top: Math.max(E + 8, Math.min(K, E + q - I - 8))
      };
      d((oe) => JSON.stringify(oe) === JSON.stringify({ style: X, placement: Q }) ? oe : { style: X, placement: Q });
    };
    _();
    const h = typeof ResizeObserver > "u" ? null : new ResizeObserver(_);
    return g && h?.observe(g), h?.observe(f), b.addEventListener("resize", _), b.addEventListener("scroll", _, !0), b.visualViewport?.addEventListener("resize", _), b.visualViewport?.addEventListener("scroll", _), () => {
      h?.disconnect(), b.removeEventListener("resize", _), b.removeEventListener("scroll", _, !0), b.visualViewport?.removeEventListener("resize", _), b.visualViewport?.removeEventListener("scroll", _);
    };
  }, [o, e, n, a, r, i, s, c?.x, c?.y]), p;
}
const ar = "_root_13mmg_2", or = {
  root: ar
}, an = T(
  function({
    className: e,
    "data-openbitfun-component": n = "scroll-area",
    "data-openbitfun-part": a = "viewport",
    orientation: r = "vertical",
    scrollbarVisibility: i = "auto",
    ...s
  }, c) {
    return /* @__PURE__ */ t(
      "div",
      {
        ...s,
        className: R(or.root, e),
        "data-openbitfun-component": n,
        "data-openbitfun-orientation": r,
        "data-openbitfun-part": a,
        "data-openbitfun-scrollbar-visibility": i,
        ref: c
      }
    );
  }
), rr = "_root_1lkhm_2", ir = "_viewport_1lkhm_3", sr = "_list_1lkhm_4", cr = "_group_1lkhm_5", lr = "_groupOptions_1lkhm_6", dr = "_option_1lkhm_7", ur = "_leading_1lkhm_8", pr = "_content_1lkhm_9", fr = "_label_1lkhm_10", hr = "_description_1lkhm_11", br = "_metadata_1lkhm_12", mr = "_indicator_1lkhm_13", gr = "_empty_1lkhm_14", _r = "_groupLabel_1lkhm_45", we = {
  root: rr,
  viewport: ir,
  list: sr,
  group: cr,
  groupOptions: lr,
  option: dr,
  leading: ur,
  content: pr,
  label: fr,
  description: hr,
  metadata: br,
  indicator: mr,
  empty: gr,
  groupLabel: _r
};
function vr(o, e) {
  typeof o == "function" ? o(e) : o && (o.current = e);
}
function Bt(o) {
  return Array.from(
    o.querySelectorAll("[data-openbitfun-listbox-option]")
  ).filter((e) => e.closest('[role="listbox"]') === o && !e.disabled && e.getAttribute("aria-disabled") !== "true");
}
function _n(o) {
  return o && typeof o.closest == "function" ? o.closest("[data-openbitfun-listbox-option]") : null;
}
function Ct(o, e, n = !0) {
  const a = o[e];
  a && (o.forEach((r, i) => {
    r.tabIndex = i === e ? 0 : -1;
  }), n && (a.focus(), a.scrollIntoView?.({ block: "nearest", inline: "nearest" })));
}
const An = T(function({
  autoFocusOption: e = !1,
  children: n,
  className: a,
  focusMode: r = "roving",
  multiple: i = !1,
  onFocusCapture: s,
  onKeyDown: c,
  scrollbarVisibility: p = "auto",
  ...d
}, g) {
  const f = Y(null), b = Y(!1), _ = W((m) => {
    f.current = m, vr(g, m);
  }, [g]);
  se(() => {
    const m = f.current;
    if (!m) return;
    const l = Bt(m);
    if (r === "virtual") {
      l.forEach(($) => {
        $.tabIndex = -1;
      });
      return;
    }
    if (l.length === 0) return;
    const x = l.findIndex(($) => $.getAttribute("aria-selected") === "true"), y = l.findIndex(($) => $.tabIndex === 0), E = x >= 0 ? x : Math.max(y, 0);
    Ct(l, E, !1), e && !b.current && (b.current = !0, Ct(l, E));
  }, [e, n, r]);
  const h = (m) => {
    if (s?.(m), m.defaultPrevented || r === "virtual") return;
    const l = _n(m.target);
    if (!l || !m.currentTarget.contains(l)) return;
    const x = Bt(m.currentTarget), y = x.indexOf(l);
    y >= 0 && Ct(x, y, !1);
  }, C = (m) => {
    if (c?.(m), m.defaultPrevented || r === "virtual") return;
    const l = _n(m.target);
    if (!l || !m.currentTarget.contains(l)) return;
    const x = Bt(m.currentTarget), y = x.indexOf(l);
    if (y < 0 || x.length === 0) return;
    let E;
    switch (m.key) {
      case "ArrowDown":
        E = (y + 1) % x.length;
        break;
      case "ArrowUp":
        E = (y - 1 + x.length) % x.length;
        break;
      case "Home":
        E = 0;
        break;
      case "End":
        E = x.length - 1;
        break;
      default:
        if (m.key.length === 1 && !m.altKey && !m.ctrlKey && !m.metaKey) {
          const $ = m.key.toLocaleLowerCase();
          for (let q = 1; q <= x.length; q += 1) {
            const z = (y + q) % x.length;
            if ((x[z]?.textContent?.trim().toLocaleLowerCase() ?? "").startsWith($)) {
              E = z;
              break;
            }
          }
        }
    }
    E !== void 0 && (m.preventDefault(), Ct(x, E));
  };
  return /* @__PURE__ */ t(
    "div",
    {
      ...d,
      "aria-multiselectable": i || void 0,
      className: R(we.root, a),
      "data-openbitfun-component": "listbox",
      "data-openbitfun-focus-mode": r,
      "data-openbitfun-multiple": i ? "true" : "false",
      onFocusCapture: h,
      onKeyDown: C,
      ref: _,
      role: "listbox",
      children: /* @__PURE__ */ t(
        an,
        {
          className: we.viewport,
          orientation: "vertical",
          scrollbarVisibility: p,
          children: /* @__PURE__ */ t("div", { className: we.list, "data-openbitfun-part": "list", children: n })
        }
      )
    }
  );
}), Mt = T(
  function({
    active: e = !1,
    children: n,
    className: a,
    description: r,
    disabled: i = !1,
    indicator: s,
    leading: c,
    metadata: p,
    selected: d = !1,
    tabIndex: g = -1,
    title: f,
    value: b,
    ..._
  }, h) {
    return /* @__PURE__ */ k(
      "button",
      {
        "data-overflow-trigger": !0,
        ..._,
        "aria-disabled": i || void 0,
        "aria-selected": d,
        className: R(we.option, a),
        "data-active": e ? "true" : "false",
        "data-overflow-active": e ? "true" : void 0,
        "data-openbitfun-listbox-option": "",
        "data-openbitfun-part": "option",
        "data-selected": d ? "true" : "false",
        "data-value": b,
        disabled: i,
        ref: h,
        role: "option",
        tabIndex: g,
        title: f,
        type: "button",
        children: [
          c != null && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: we.leading, "data-openbitfun-part": "leading", children: c }),
          /* @__PURE__ */ k("span", { className: we.content, "data-openbitfun-part": "content", children: [
            /* @__PURE__ */ t(ie, { title: f === "" ? "" : void 0, className: we.label, "data-openbitfun-part": "label", marqueeActive: e, children: n }),
            r != null && /* @__PURE__ */ t("span", { className: we.description, "data-openbitfun-part": "description", children: r })
          ] }),
          p != null && /* @__PURE__ */ t(ie, { title: f === "" ? "" : void 0, className: we.metadata, "data-openbitfun-part": "metadata", marqueeActive: e, children: p }),
          /* @__PURE__ */ t("span", { "aria-hidden": "true", className: we.indicator, "data-openbitfun-part": "indicator", children: s ?? (d ? /* @__PURE__ */ t(de, { name: "check-line" }) : null) })
        ]
      }
    );
  }
), In = T(
  function({ children: e, className: n, label: a, ...r }, i) {
    const s = Re(), c = a == null ? void 0 : s;
    return /* @__PURE__ */ k(
      "div",
      {
        ...r,
        "aria-labelledby": c,
        className: R(we.group, n),
        "data-openbitfun-part": "group",
        ref: i,
        role: "group",
        children: [
          c && /* @__PURE__ */ t("div", { className: we.groupLabel, "data-openbitfun-part": "group-label", id: c, children: a }),
          /* @__PURE__ */ t("div", { className: we.groupOptions, "data-openbitfun-part": "group-options", children: e })
        ]
      }
    );
  }
), Jt = T(
  function({ className: e, ...n }, a) {
    return /* @__PURE__ */ t(
      "div",
      {
        ...n,
        className: R(we.empty, e),
        "data-openbitfun-part": "empty",
        ref: a,
        role: "status"
      }
    );
  }
), yr = "_root_1tf9k_2", xr = "_field_1tf9k_7", wr = "_clear_1tf9k_25", Nr = "_footer_1tf9k_76", kr = "_icon_1tf9k_141", $r = "_shortcut_1tf9k_154", st = {
  root: yr,
  field: xr,
  clear: wr,
  footer: Nr,
  icon: kr,
  shortcut: $r
}, Cr = T(function({
  className: e,
  clearLabel: n,
  disabled: a,
  footer: r,
  leadingIcon: i,
  onClear: s,
  onKeyDown: c,
  onSearch: p,
  readOnly: d,
  shortcut: g,
  trailing: f,
  variant: b = "default",
  ..._
}, h) {
  const C = (y) => {
    c?.(y), !y.defaultPrevented && y.key === "Enter" && p?.(y.currentTarget.value);
  }, m = n && s ? /* @__PURE__ */ t(
    ve,
    {
      "aria-label": n,
      className: st.clear,
      disabled: a || d,
      icon: /* @__PURE__ */ t(de, { name: "xmark" }),
      onClick: (y) => {
        !a && !d && s(y);
      },
      onMouseDown: (y) => y.preventDefault(),
      shape: "circle",
      size: "xs",
      variant: "quiet"
    }
  ) : void 0, l = g === void 0 ? void 0 : /* @__PURE__ */ t("span", { "aria-hidden": "true", className: st.shortcut, children: g }), x = f === void 0 && l === void 0 && m === void 0 ? void 0 : /* @__PURE__ */ k(je, { children: [
    f,
    l,
    m
  ] });
  return /* @__PURE__ */ k("span", { className: R(st.root, e), "data-openbitfun-component": "search-field", "data-variant": b, children: [
    /* @__PURE__ */ t(
      Gn,
      {
        ..._,
        className: st.field,
        disabled: a,
        leading: i === void 0 ? void 0 : /* @__PURE__ */ t("span", { "aria-hidden": "true", className: st.icon, "data-openbitfun-part": "icon", children: i }),
        onKeyDown: C,
        ref: h,
        readOnly: d,
        trailing: x,
        type: "search"
      }
    ),
    b === "panel" && r != null && /* @__PURE__ */ t("span", { className: st.footer, "data-openbitfun-part": "footer", children: r })
  ] });
}), Ar = "_root_gnqv9_2", Ir = "_visibleLabel_gnqv9_3", Lr = "_control_gnqv9_4", Sr = "_trigger_gnqv9_5", Mr = "_value_gnqv9_6", Pr = "_singleValue_gnqv9_7", Dr = "_valueLeading_gnqv9_8", Er = "_valueLabel_gnqv9_9", Rr = "_placeholder_gnqv9_10", zr = "_tags_gnqv9_11", Tr = "_tag_gnqv9_11", qr = "_indicator_gnqv9_13", Or = "_popover_gnqv9_14", Fr = "_search_gnqv9_15", Vr = "_divider_gnqv9_16", Br = "_options_gnqv9_17", Hr = "_message_gnqv9_18", Kr = "_error_gnqv9_19", jr = "_clear_gnqv9_109", Yr = "_searchField_gnqv9_337", Gr = "_collapse_gnqv9_344", Wr = "_listbox_gnqv9_363", Ur = "_spinner_gnqv9_393", ne = {
  root: Ar,
  visibleLabel: Ir,
  control: Lr,
  trigger: Sr,
  value: Mr,
  singleValue: Pr,
  valueLeading: Dr,
  valueLabel: Er,
  placeholder: Rr,
  tags: zr,
  tag: Tr,
  indicator: qr,
  popover: Or,
  search: Fr,
  divider: Vr,
  options: Br,
  message: Hr,
  error: Kr,
  clear: jr,
  searchField: Yr,
  collapse: Gr,
  listbox: Wr,
  spinner: Ur
}, Xr = typeof window > "u" ? se : yt;
function Jr(o) {
  const e = o.nativeEvent;
  return e.isComposing || e.keyCode === 229;
}
function Qr(o, e) {
  const n = e.trim().toLocaleLowerCase();
  return n ? o.label.toLocaleLowerCase().includes(n) || String(o.value).toLocaleLowerCase().includes(n) || typeof o.description == "string" && o.description.toLocaleLowerCase().includes(n) : !0;
}
function bt(o, e) {
  if (o.length === 0) return -1;
  let n = e === 1 ? 0 : o.length - 1;
  for (; n >= 0 && n < o.length; ) {
    const a = o[n];
    if (a?.kind !== "option" || !a.option.disabled) return n;
    n += e;
  }
  return -1;
}
const Ln = T(function(e, n) {
  const { mode: a } = e, r = Dt(), i = e, {
    "aria-describedby": s,
    "aria-invalid": c,
    "aria-label": p,
    "aria-labelledby": d,
    className: g,
    clearable: f = !1,
    defaultOpen: b = !1,
    disabled: _ = !1,
    errorMessage: h,
    filterOption: C = Qr,
    id: m,
    invalid: l = !1,
    label: x,
    loading: y = !1,
    onCreateValue: E,
    onOpenChange: $,
    open: q,
    options: z = [],
    placement: V = "bottom",
    placeholder: F,
    required: S = !1,
    size: M = "md",
    ...L
  } = i;
  delete L.defaultValue, delete L.onValueChange, delete L.value, delete L.maxVisibleTags, delete L.showSelectAll;
  const w = L, N = Zt(), A = a === "multiple", P = i.defaultValue, O = i.value, j = i.onValueChange, Q = A ? i.maxVisibleTags ?? 3 : 0, H = A && (i.showSelectAll ?? !1), I = F ?? N.messages.selectPlaceholder, v = z, K = Re(), X = m ?? `openbitfun-${A ? "multi-select" : "combobox"}-${K}`, oe = `${X}-label`, ge = `${X}-listbox`, _e = `${X}-error`, [he, be] = ue(b && !_), [U, ce] = ue(() => {
    if (A) {
      const B = P;
      return B ? [...B] : [];
    }
    const u = P;
    return u === void 0 || u === "" ? [] : [u];
  }), [me, Ne] = ue(""), [re, pe] = ue(-1), [Me, Je] = ue(!1), ke = Y(null), $e = Y(null), ze = Y(null), Qe = Y(null), Ye = Y(!1), Ze = De(() => [ke], []), Z = !_ && (q ?? he), te = De(() => {
    if (A) {
      const B = O;
      return B ? [...B] : U;
    }
    const u = O;
    return u !== void 0 ? u === "" ? [] : [u] : U;
  }, [O, A, U]), Te = l || c === !0 || c === "true", et = W((u) => {
    ke.current = u, typeof n == "function" ? n(u) : n && (n.current = u);
  }, [n]), Le = W((u) => {
    u !== Z && (q === void 0 && be(u), $?.(u));
  }, [$, q, Z]), D = W((u) => {
    Ye.current = u, Le(!1), Ne(""), pe(-1);
  }, [Le]), G = W((u) => {
    O === void 0 && ce(u), j?.(A ? u : u[0] ?? "");
  }, [O, A, j]), ae = De(
    () => me.trim() ? v.filter((u) => C(u, me)) : [...v],
    [C, v, me]
  ), fe = De(() => {
    const u = me.trim();
    if (!E || !u) return null;
    const B = u.toLocaleLowerCase();
    return v.some((le) => String(le.value).toLocaleLowerCase() === B || le.label.toLocaleLowerCase() === B) ? null : u;
  }, [E, v, me]), ee = De(() => {
    const u = [];
    return H && ae.some((B) => !B.disabled) && u.push({ kind: "all" }), ae.forEach((B) => u.push({ kind: "option", option: B })), fe && u.push({ kind: "create", value: fe }), u;
  }, [fe, ae, H]), Ve = W((u) => `${ge}-option-${u}`, [ge]), xt = W((u, B) => {
    if (ee.length === 0) return -1;
    let J = u;
    for (let le = 0; le < ee.length; le += 1) {
      J += B, J < 0 && (J = ee.length - 1), J >= ee.length && (J = 0);
      const fn = ee[J];
      if (fn?.kind !== "option" || !fn.option.disabled) return J;
    }
    return -1;
  }, [ee]), dt = W((u) => {
    if (!(_ || y || u.disabled)) {
      if (A) {
        G(te.includes(u.value) ? te.filter((B) => B !== u.value) : [...te, u.value]);
        return;
      }
      G([u.value]), D(!0);
    }
  }, [D, G, _, y, A, te]), it = W((u) => {
    if (!E || _ || y) return;
    const B = E(u);
    B !== void 0 && (A ? te.includes(B) || G([...te, B]) : (G([B]), D(!0)), Ne(""));
  }, [D, G, _, y, A, E, te]), zt = W(() => {
    if (!A || _ || y) return;
    const u = ae.filter((J) => !J.disabled).map((J) => J.value), B = u.length > 0 && u.every((J) => te.includes(J));
    G(B ? te.filter((J) => !u.includes(J)) : [.../* @__PURE__ */ new Set([...te, ...u])]);
  }, [G, _, ae, y, A, te]), wt = W((u) => {
    const B = ee[u];
    B && (B.kind === "all" ? zt() : B.kind === "create" ? it(B.value) : dt(B.option));
  }, [ee, dt, it, zt]), Nt = W((u = 1, B = !1) => {
    if (_) return;
    if (Ye.current = !1, Je(B), Le(!0), !B) {
      pe(-1);
      return;
    }
    const J = ee.findIndex((le) => le.kind === "option" && te.includes(le.option.value) && !le.option.disabled);
    pe(J >= 0 ? J : bt(ee, u));
  }, [_, ee, te, Le]), Rn = W((u) => {
    if (!_) {
      if (u.key === "ArrowDown" || u.key === "ArrowUp") {
        u.preventDefault(), Z ? pe((B) => xt(B, u.key === "ArrowDown" ? 1 : -1)) : Nt(u.key === "ArrowDown" ? 1 : -1, !0);
        return;
      }
      if (u.key === "Home" && Z) {
        u.preventDefault(), pe(bt(ee, 1));
        return;
      }
      if (u.key === "End" && Z) {
        u.preventDefault(), pe(bt(ee, -1));
        return;
      }
      (u.key === "Enter" || u.key === " ") && (u.preventDefault(), Z ? re >= 0 && wt(re) : Nt(1, !0));
    }
  }, [wt, re, _, xt, ee, Nt, Z]), zn = W((u) => {
    if (u.key === "Enter" && Jr(u)) {
      u.stopPropagation();
      return;
    }
    if (u.key === "ArrowDown" || u.key === "ArrowUp") {
      u.preventDefault(), u.stopPropagation(), pe((B) => xt(B, u.key === "ArrowDown" ? 1 : -1));
      return;
    }
    if (u.key === "Home" || u.key === "End") {
      u.preventDefault(), u.stopPropagation(), pe(bt(ee, u.key === "Home" ? 1 : -1));
      return;
    }
    if (u.key === "Enter") {
      u.preventDefault(), u.stopPropagation(), re >= 0 ? wt(re) : fe && it(fe);
      return;
    }
    if (u.key === "Tab") {
      const B = me.trim(), J = B ? v.find((le) => String(le.value).toLocaleLowerCase() === B.toLocaleLowerCase() || le.label.toLocaleLowerCase() === B.toLocaleLowerCase()) : void 0;
      pa(() => {
        J && !J.disabled ? dt(J) : fe && it(fe), D(!0);
      });
    }
  }, [wt, re, D, fe, xt, ee, v, me, dt, it]);
  en({
    branchRefs: Ze,
    enabled: Z,
    layerRef: Qe,
    onDismiss: (u) => D(u === "escape-key"),
    ownerDocument: ke.current?.ownerDocument
  });
  const Tt = nn({
    open: Z,
    anchorRef: $e,
    layerRef: Qe,
    placement: V,
    matchWidth: !0,
    overlapAnchor: !0,
    revision: `${me}:${ae.length}:${y}`
  }), rn = Tt !== null;
  Xr(() => {
    Z ? rn && ze.current?.focus({ preventScroll: !0 }) : Ye.current && (Ye.current = !1, $e.current?.focus({ preventScroll: !0 }));
  }, [rn, Z]), se(() => {
    !Z || re < 0 || document.getElementById(Ve(re))?.scrollIntoView?.({ block: "nearest" });
  }, [re, Ve, Z]);
  const ut = De(() => te.map((u) => v.find((B) => B.value === u) ?? { label: String(u), value: u }), [v, te]), kt = te.length > 0, sn = ae.some((u) => !u.disabled) && ae.filter((u) => !u.disabled).every((u) => te.includes(u.value)), cn = De(() => {
    const u = [], B = /* @__PURE__ */ new Map();
    return ae.forEach((J) => {
      if (!J.group) {
        u.push(J);
        return;
      }
      const le = B.get(J.group) ?? [];
      le.push(J), B.set(J.group, le);
    }), { groups: B, ungrouped: u };
  }, [ae]), ln = (u) => {
    const B = ee.findIndex((le) => le.kind === "option" && le.option === u), J = te.includes(u.value);
    return /* @__PURE__ */ t(
      Mt,
      {
        active: re === B,
        "aria-label": typeof u.description == "string" ? `${u.label}: ${u.description}` : u.label,
        description: u.description,
        disabled: u.disabled || y,
        id: Ve(B),
        indicator: J ? /* @__PURE__ */ t(de, { name: "check-line" }) : null,
        leading: u.leading,
        metadata: u.metadata,
        onClick: () => dt(u),
        onMouseDown: (le) => le.preventDefault(),
        selected: J,
        value: u.value,
        "data-testid": u.testId,
        children: u.label
      },
      `${typeof u.value}:${u.value}`
    );
  }, Tn = Z && re >= 0 ? Ve(re) : void 0, dn = p ?? (x || m || typeof I != "string" ? void 0 : I), qt = p ? d : d ?? (x ? oe : void 0), un = [
    s,
    h ? _e : void 0
  ].filter(Boolean).join(" ") || void 0, pn = Z ? /* @__PURE__ */ k(
    "div",
    {
      className: ne.popover,
      "data-openbitfun-component": A ? "multi-select-popup" : "combobox-popup",
      "data-openbitfun-part": "popover",
      "data-openbitfun-native-webview-occlusion": !0,
      "data-keyboard-open": Me ? "true" : "false",
      "data-invalid": Te ? "true" : "false",
      "data-placement": Tt?.placement ?? V,
      "data-size": M,
      ref: Qe,
      style: Tt?.style ?? { position: "fixed", visibility: "hidden" },
      children: [
        /* @__PURE__ */ k("div", { className: ne.search, "data-openbitfun-part": "search", children: [
          /* @__PURE__ */ t(
            Cr,
            {
              "aria-activedescendant": Tn,
              "aria-autocomplete": "list",
              "aria-controls": ge,
              "aria-describedby": un,
              "aria-expanded": Z,
              "aria-label": dn ?? (m || qt ? void 0 : N.messages.searchOptions),
              "aria-labelledby": qt,
              "aria-required": S || void 0,
              "aria-busy": y || void 0,
              autoComplete: "off",
              className: ne.searchField,
              clearLabel: me ? N.messages.clearSelection : void 0,
              id: X,
              invalid: Te,
              leadingIcon: /* @__PURE__ */ t(de, { name: "search", size: "sm" }),
              onClear: me ? () => {
                Ne(""), pe(bt(ee, 1));
              } : void 0,
              onKeyDown: zn,
              onValueChange: (u) => {
                Ne(u), pe(-1);
              },
              placeholder: N.messages.searchOptions,
              ref: ze,
              role: "combobox",
              size: M,
              value: me,
              variant: "embedded"
            }
          ),
          /* @__PURE__ */ t(
            ve,
            {
              "aria-label": N.messages.dialogClose,
              className: ne.collapse,
              "data-openbitfun-part": "collapse",
              icon: /* @__PURE__ */ t(de, { name: "chevron-up" }),
              onClick: () => D(!0),
              size: "xs",
              variant: "quiet"
            }
          )
        ] }),
        /* @__PURE__ */ t("div", { "aria-hidden": "true", className: ne.divider, "data-openbitfun-part": "divider" }),
        /* @__PURE__ */ t("div", { className: ne.options, "data-openbitfun-part": "options", children: /* @__PURE__ */ t(
          An,
          {
            "aria-label": p ?? (typeof x == "string" ? x : "Options"),
            className: ne.listbox,
            focusMode: "virtual",
            id: ge,
            multiple: A,
            children: y && ae.length === 0 ? /* @__PURE__ */ k(Jt, { className: ne.message, children: [
              /* @__PURE__ */ t(Wn, { "aria-hidden": "true", className: ne.spinner }),
              /* @__PURE__ */ t("span", { children: N.messages.loading })
            ] }) : ee.length === 0 ? /* @__PURE__ */ t(Jt, { children: N.messages.noOptions }) : /* @__PURE__ */ k(je, { children: [
              ee[0]?.kind === "all" && /* @__PURE__ */ t(
                Mt,
                {
                  active: re === 0,
                  id: Ve(0),
                  indicator: sn ? /* @__PURE__ */ t(de, { name: "check-line" }) : null,
                  onClick: zt,
                  onMouseDown: (u) => u.preventDefault(),
                  selected: sn,
                  children: N.messages.selectAll
                }
              ),
              cn.ungrouped.map(ln),
              [...cn.groups].map(([u, B]) => /* @__PURE__ */ t(In, { label: u, children: B.map(ln) }, u)),
              fe && (() => {
                const u = ee.findIndex((B) => B.kind === "create");
                return /* @__PURE__ */ k(
                  Mt,
                  {
                    active: re === u,
                    id: Ve(u),
                    leading: /* @__PURE__ */ t(de, { name: "plus" }),
                    onClick: () => it(fe),
                    onMouseDown: (B) => B.preventDefault(),
                    selected: te.includes(fe),
                    value: fe,
                    children: [
                      N.messages.createValue,
                      ": ",
                      fe
                    ]
                  }
                );
              })()
            ] })
          }
        ) })
      ]
    }
  ) : null, Ot = ut[0];
  return /* @__PURE__ */ k(
    "div",
    {
      ...w,
      className: R(ne.root, g),
      "data-openbitfun-component": A ? "multi-select" : "combobox",
      "data-disabled": _ ? "true" : "false",
      "data-field-surface": r,
      "data-invalid": Te ? "true" : "false",
      "data-open": Z ? "true" : "false",
      "data-size": M,
      ref: et,
      children: [
        x != null && /* @__PURE__ */ t("label", { className: ne.visibleLabel, "data-openbitfun-part": "label", htmlFor: X, id: oe, children: x }),
        /* @__PURE__ */ k(
          "div",
          {
            "aria-hidden": Z || void 0,
            className: ne.control,
            "data-openbitfun-part": "control",
            "data-tags": A && kt ? "true" : "false",
            children: [
              A && kt && /* @__PURE__ */ k("span", { className: ne.tags, "data-openbitfun-part": "tags", children: [
                ut.slice(0, Math.max(1, Q)).map((u) => /* @__PURE__ */ k("span", { className: ne.tag, "data-openbitfun-part": "tag", children: [
                  /* @__PURE__ */ t(ie, { children: u.label }),
                  /* @__PURE__ */ t(
                    ve,
                    {
                      "aria-label": `${N.messages.clearSelection}: ${u.label}`,
                      disabled: _,
                      icon: /* @__PURE__ */ t(de, { name: "xmark" }),
                      onClick: (B) => {
                        B.stopPropagation(), G(te.filter((J) => J !== u.value));
                      },
                      onMouseDown: (B) => B.preventDefault(),
                      shape: "circle",
                      size: "xs",
                      tabIndex: Z ? -1 : void 0,
                      variant: "quiet"
                    }
                  )
                ] }, `${typeof u.value}:${u.value}`)),
                ut.length > Math.max(1, Q) && /* @__PURE__ */ k("span", { className: ne.tag, children: [
                  "+",
                  ut.length - Math.max(1, Q)
                ] })
              ] }),
              /* @__PURE__ */ t(
                "button",
                {
                  "data-overflow-trigger": !0,
                  "aria-controls": Z ? void 0 : ge,
                  "aria-describedby": un,
                  "aria-expanded": Z ? void 0 : !1,
                  "aria-haspopup": "listbox",
                  "aria-invalid": Te || void 0,
                  "aria-label": dn,
                  "aria-labelledby": qt,
                  "aria-required": S || void 0,
                  "aria-busy": y || void 0,
                  className: ne.trigger,
                  "data-openbitfun-part": "trigger",
                  disabled: _,
                  id: Z ? void 0 : X,
                  onClick: () => {
                    Z ? D(!1) : Nt(1, !1);
                  },
                  onKeyDown: Rn,
                  ref: $e,
                  role: Z ? void 0 : "combobox",
                  tabIndex: Z ? -1 : void 0,
                  type: "button",
                  children: /* @__PURE__ */ t("span", { className: ne.value, "data-openbitfun-part": "value", children: kt ? A ? /* @__PURE__ */ t(ie, { className: ne.valueLabel, children: ut.map((u) => u.label).join(", ") }) : /* @__PURE__ */ k("span", { className: ne.singleValue, children: [
                    Ot?.leading && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: ne.valueLeading, children: Ot.leading }),
                    /* @__PURE__ */ t(ie, { className: ne.valueLabel, children: Ot?.label })
                  ] }) : /* @__PURE__ */ t(ie, { className: ne.placeholder, children: I }) })
                }
              ),
              f && kt && !_ && /* @__PURE__ */ t(
                ve,
                {
                  "aria-label": N.messages.clearSelection,
                  className: ne.clear,
                  icon: /* @__PURE__ */ t(de, { name: "xmark" }),
                  onClick: (u) => {
                    u.stopPropagation(), G([]), Ne("");
                  },
                  size: "sm",
                  tabIndex: Z ? -1 : void 0,
                  variant: "quiet"
                }
              ),
              /* @__PURE__ */ t("span", { "aria-hidden": "true", className: ne.indicator, "data-openbitfun-part": "indicator", children: /* @__PURE__ */ t(de, { name: "chevron-down" }) })
            ]
          }
        ),
        h ? /* @__PURE__ */ t("span", { className: ne.error, "data-openbitfun-part": "message", id: _e, children: h }) : null,
        pn && /* @__PURE__ */ t(Et, { ownerDocument: $e.current?.ownerDocument, children: pn })
      ]
    }
  );
}), Hl = T(function(e, n) {
  return /* @__PURE__ */ t(Ln, { ...e, mode: "single", ref: n });
}), Kl = T(function(e, n) {
  return /* @__PURE__ */ t(Ln, { ...e, mode: "multiple", ref: n });
}), Zr = "_content_1x36o_2", ei = "_messageRow_1x36o_3", ti = "_icon_1x36o_4", ni = "_message_1x36o_3", ai = "_preview_1x36o_6", mt = {
  content: Zr,
  messageRow: ei,
  icon: ti,
  message: ni,
  preview: ai
}, oi = {
  error: /* @__PURE__ */ t(de, { glyph: aa }),
  info: /* @__PURE__ */ t(de, { name: "info" }),
  success: /* @__PURE__ */ t(de, { name: "check-circle" }),
  warning: /* @__PURE__ */ t(de, { glyph: na })
}, jl = T(
  function({
    cancelText: e,
    closeOnEscape: n = !0,
    closeOnPointerOutside: a = !0,
    confirmDanger: r = !1,
    confirmText: i,
    icon: s,
    message: c,
    onActionError: p,
    onConfirm: d,
    onOpenChange: g,
    onSecondary: f,
    open: b,
    pendingAction: _,
    preview: h,
    secondaryText: C,
    showCancel: m = !0,
    showCloseButton: l = !1,
    testId: x,
    title: y,
    type: E = "warning"
  }, $) {
    const q = Zt(), z = Y(null), V = Y(!0), [F, S] = ue(null), M = _ ?? F, L = M !== null, w = s === !1 ? null : s ?? oi[E], N = c != null && c !== "", A = h != null && h !== "", P = e ?? q.messages.confirmCancel, O = i ?? q.messages.confirmAction;
    se(() => () => {
      V.current = !1;
    }, []), se(() => {
      b || S(null);
    }, [b]);
    const j = W(async (H, I) => {
      if (!(!I || L))
        try {
          const v = I();
          v && typeof v.then == "function" && (S(H), await v);
        } catch (v) {
          p?.(v, H);
        } finally {
          V.current && S(null);
        }
    }, [L, p]), Q = W((H) => {
      L || g(!1, H);
    }, [L, g]);
    return /* @__PURE__ */ k(
      Un,
      {
        closeOnEscape: !L && n,
        closeOnPointerOutside: !L && a,
        "data-testid": x,
        initialFocusRef: z,
        onOpenChange: (H, I) => Q(I),
        open: b,
        ref: $,
        role: "alertdialog",
        size: "sm",
        children: [
          /* @__PURE__ */ k(Xn, { children: [
            /* @__PURE__ */ t(Jn, { children: /* @__PURE__ */ t(Qn, { children: y }) }),
            l ? /* @__PURE__ */ t(Zn, { disabled: L }) : null
          ] }),
          N || A ? /* @__PURE__ */ t(ea, { children: /* @__PURE__ */ k("div", { className: mt.content, "data-openbitfun-component": "confirm-dialog", "data-openbitfun-part": "content", children: [
            N ? /* @__PURE__ */ k(
              "div",
              {
                className: mt.messageRow,
                "data-openbitfun-component": "confirm-dialog",
                "data-openbitfun-part": "messageRow",
                children: [
                  w !== null ? /* @__PURE__ */ t(
                    "span",
                    {
                      "aria-hidden": "true",
                      className: mt.icon,
                      "data-openbitfun-component": "confirm-dialog",
                      "data-openbitfun-part": "icon",
                      "data-openbitfun-status": E === "error" ? "danger" : E,
                      children: w
                    }
                  ) : null,
                  /* @__PURE__ */ t(
                    "div",
                    {
                      className: mt.message,
                      "data-openbitfun-component": "confirm-dialog",
                      "data-openbitfun-part": "message",
                      children: c
                    }
                  )
                ]
              }
            ) : null,
            A ? /* @__PURE__ */ t(
              "div",
              {
                className: mt.preview,
                "data-openbitfun-component": "confirm-dialog",
                "data-openbitfun-part": "preview",
                children: typeof h == "string" ? /* @__PURE__ */ t("pre", { children: h }) : h
              }
            ) : null
          ] }) }) : null,
          /* @__PURE__ */ k(ta, { children: [
            m ? /* @__PURE__ */ t(Ft, { disabled: L, onClick: () => Q("cancel-button"), variant: "fill", children: P }) : null,
            C != null ? /* @__PURE__ */ t(
              Ft,
              {
                disabled: L,
                loading: M === "secondary",
                onClick: () => {
                  j("secondary", f);
                },
                variant: "outline",
                children: C
              }
            ) : null,
            /* @__PURE__ */ t(
              Ft,
              {
                disabled: L,
                loading: M === "confirm",
                onClick: () => {
                  j("confirm", d);
                },
                ref: z,
                tone: r || E === "error" ? "danger" : "neutral",
                variant: "primary",
                children: O
              }
            )
          ] })
        ]
      }
    );
  }
), ri = "_root_16vrx_2", ii = "_content_16vrx_47", si = "_labelRow_16vrx_55", ci = "_label_16vrx_55", li = "_required_16vrx_84", di = "_labelAction_16vrx_88", ui = "_description_16vrx_95", pi = "_error_16vrx_104", fi = "_control_16vrx_114", hi = "_controlAdornment_16vrx_125", Pe = {
  root: ri,
  content: ii,
  labelRow: si,
  label: ci,
  required: li,
  labelAction: di,
  description: ui,
  error: pi,
  control: fi,
  controlAdornment: hi
}, Yl = T(function({
  children: e,
  className: n,
  controlLeading: a,
  controlTrailing: r,
  controlWidth: i = "auto",
  description: s,
  error: c,
  horizontalGap: p = "md",
  label: d,
  labelAction: g,
  labelWidth: f = "auto",
  orientation: b = "vertical",
  required: _ = !1,
  ...h
}, C) {
  const m = Re(), l = e.props.id ?? `openbitfun-field-${m}`, x = s == null ? void 0 : `${l}-description`, y = c != null && c !== !1, E = y ? `${l}-error` : void 0, $ = [e.props["aria-describedby"], x, E].filter((V) => !!V).join(" ") || void 0, q = _ || e.props.required === !0, z = la(e, {
    "aria-describedby": $,
    "aria-invalid": y ? !0 : e.props["aria-invalid"],
    id: l,
    required: q || void 0
  });
  return /* @__PURE__ */ k(
    "div",
    {
      ...h,
      className: R(Pe.root, n),
      "data-openbitfun-component": "field",
      "data-control-width": i,
      "data-horizontal-gap": p,
      "data-label-width": f,
      "data-invalid": y ? "true" : void 0,
      "data-orientation": b,
      "data-required": q ? "true" : "false",
      ref: C,
      children: [
        /* @__PURE__ */ k("span", { className: Pe.content, "data-openbitfun-part": "content", children: [
          /* @__PURE__ */ k("span", { className: Pe.labelRow, "data-openbitfun-part": "label-row", children: [
            /* @__PURE__ */ k("label", { className: Pe.label, htmlFor: l, children: [
              /* @__PURE__ */ t("span", { children: d }),
              q && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Pe.required, "data-openbitfun-part": "required", children: "*" })
            ] }),
            g != null && /* @__PURE__ */ t("span", { className: Pe.labelAction, "data-openbitfun-part": "label-action", children: g })
          ] }),
          x !== void 0 && /* @__PURE__ */ t("span", { className: Pe.description, "data-openbitfun-part": "description", id: x, children: s })
        ] }),
        /* @__PURE__ */ k("span", { className: Pe.control, "data-openbitfun-part": "control", children: [
          a != null && /* @__PURE__ */ t("span", { className: Pe.controlAdornment, "data-openbitfun-part": "control-leading", children: a }),
          z,
          r != null && /* @__PURE__ */ t("span", { className: Pe.controlAdornment, "data-openbitfun-part": "control-trailing", children: r })
        ] }),
        y && /* @__PURE__ */ t("span", { className: Pe.error, "data-openbitfun-part": "error", id: E, children: c })
      ]
    }
  );
}), bi = "_section_1fpff_2", mi = "_header_1fpff_3", gi = "_headingRegion_1fpff_4", _i = "_leading_1fpff_5", vi = "_headingContent_1fpff_6", yi = "_title_1fpff_7", xi = "_description_1fpff_8", wi = "_actions_1fpff_9", Ni = "_group_1fpff_10", ki = "_row_1fpff_11", qe = {
  section: bi,
  header: mi,
  headingRegion: gi,
  leading: _i,
  headingContent: vi,
  title: yi,
  description: xi,
  actions: wi,
  group: Ni,
  row: ki
}, Gl = T(
  function({
    actions: e,
    children: n,
    className: a,
    description: r,
    headingAs: i = "h2",
    leading: s,
    title: c,
    ...p
  }, d) {
    return /* @__PURE__ */ k(
      "section",
      {
        ...p,
        className: R(qe.section, a),
        "data-openbitfun-component": "form-section",
        ref: d,
        children: [
          c != null || r != null || s != null || e != null ? /* @__PURE__ */ k("div", { className: qe.header, "data-openbitfun-part": "header", children: [
            c != null || r != null || s != null ? /* @__PURE__ */ k("div", { className: qe.headingRegion, "data-openbitfun-part": "heading-region", children: [
              s != null && /* @__PURE__ */ t("div", { className: qe.leading, "data-openbitfun-part": "leading", children: s }),
              c != null || r != null ? /* @__PURE__ */ k("div", { className: qe.headingContent, "data-openbitfun-part": "heading-content", children: [
                c != null && kn(
                  i,
                  { className: qe.title, "data-openbitfun-part": "title" },
                  c
                ),
                r != null && /* @__PURE__ */ t("div", { className: qe.description, "data-openbitfun-part": "description", children: r })
              ] }) : null
            ] }) : null,
            e != null && /* @__PURE__ */ t("div", { className: qe.actions, "data-openbitfun-part": "actions", children: e })
          ] }) : null,
          n
        ]
      }
    );
  }
), Wl = T(
  function({
    appearance: e = "subtle",
    children: n,
    className: a,
    dividers: r = !0,
    fieldSurface: i = "default",
    ...s
  }, c) {
    return /* @__PURE__ */ t(oa.Provider, { value: i, children: /* @__PURE__ */ t(
      "div",
      {
        ...s,
        className: R(qe.group, a),
        "data-appearance": e,
        "data-openbitfun-component": "field-group",
        "data-dividers": r ? "true" : "false",
        "data-field-surface": i,
        ref: c,
        children: n
      }
    ) });
  }
), Ul = T(
  function({
    align: e = "center",
    children: n,
    className: a,
    padding: r = "md",
    ...i
  }, s) {
    return /* @__PURE__ */ t(
      "div",
      {
        ...i,
        className: R(qe.row, a),
        "data-align": e,
        "data-openbitfun-part": "row",
        "data-padding": r,
        ref: s,
        children: n
      }
    );
  }
), $i = "_root_2jhek_2", Ci = "_icon_2jhek_26", Ai = "_label_2jhek_31", Ht = {
  root: $i,
  icon: Ci,
  label: Ai
}, Xl = T(function({
  children: e,
  className: n,
  icon: a,
  ...r
}, i) {
  return /* @__PURE__ */ k(
    "kbd",
    {
      ...r,
      className: R(Ht.root, n),
      "data-openbitfun-component": "key-hint",
      ref: i,
      children: [
        a != null && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Ht.icon, "data-openbitfun-part": "icon", children: a }),
        /* @__PURE__ */ t("span", { className: Ht.label, "data-openbitfun-part": "label", children: e })
      ]
    }
  );
}), Ii = "_root_2x5iy_2", Li = "_icon_2x5iy_3", Si = "_label_2x5iy_4", Kt = {
  root: Ii,
  icon: Li,
  label: Si
}, Jl = T(function({
  children: e,
  className: n,
  leadingIcon: a,
  type: r = "button",
  ...i
}, s) {
  return /* @__PURE__ */ k(
    "button",
    {
      "data-overflow-trigger": !0,
      ...i,
      className: R(Kt.root, n),
      "data-openbitfun-component": "launcher-button",
      "data-openbitfun-part": "root",
      ref: s,
      type: r,
      children: [
        a != null && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Kt.icon, "data-openbitfun-part": "icon", children: a }),
        /* @__PURE__ */ t(ie, { className: Kt.label, "data-openbitfun-part": "label", children: e })
      ]
    }
  );
}), Mi = "_root_vf2p5_2", Pi = "_label_vf2p5_5", Di = "_control_vf2p5_6", Ei = "_input_vf2p5_10", Ri = "_unit_vf2p5_11", zi = "_buttons_vf2p5_13", ct = {
  root: Mi,
  label: Pi,
  control: Di,
  input: Ei,
  unit: Ri,
  buttons: zi
}, Ql = T(function({
  className: e,
  decrementLabel: n = "Decrease value",
  disabled: a = !1,
  disableWheel: r = !1,
  formatValue: i,
  incrementLabel: s = "Increase value",
  label: c,
  max: p = Number.POSITIVE_INFINITY,
  min: d = Number.NEGATIVE_INFINITY,
  onBlur: g,
  onValueChange: f,
  onFocus: b,
  onKeyDown: _,
  precision: h = 0,
  showButtons: C = !0,
  size: m = "md",
  step: l = 1,
  unit: x,
  value: y,
  variant: E = "default",
  id: $,
  required: q,
  "aria-label": z,
  "aria-labelledby": V,
  "aria-describedby": F,
  "aria-invalid": S
}, M) {
  const L = Dt(), w = W((v) => h > 0 ? v.toFixed(h) : String(Math.round(v)), [h]), N = W((v) => Math.min(p, Math.max(d, v)), [p, d]), [A, P] = ue(() => w(y)), [O, j] = ue(!1), Q = Y(!1);
  se(() => {
    O || P(w(y));
  }, [O, w, y]);
  const H = W(() => {
    const v = Number.parseFloat(A);
    if (Number.isFinite(v)) {
      const K = N(v);
      f(K), P(w(K));
    } else
      P(w(y));
    j(!1);
  }, [N, A, w, f, y]), I = (v) => f(N(y + v));
  return /* @__PURE__ */ k("span", { className: R(ct.root, e), "data-openbitfun-component": "number-input", "data-disabled": a ? "true" : "false", "data-field-surface": L, "data-size": m, "data-variant": E, children: [
    c && /* @__PURE__ */ t("span", { className: ct.label, "data-openbitfun-part": "label", children: c }),
    /* @__PURE__ */ k(
      "span",
      {
        className: ct.control,
        "data-openbitfun-part": "control",
        onWheel: (v) => {
          a || r || document.activeElement !== v.currentTarget.querySelector("input") || (v.preventDefault(), I(v.deltaY < 0 ? l : -l));
        },
        children: [
          /* @__PURE__ */ t(
            "input",
            {
              id: $,
              required: q,
              "aria-labelledby": V,
              "aria-describedby": F,
              "aria-invalid": S,
              "aria-label": z ?? c,
              className: ct.input,
              "data-openbitfun-part": "input",
              disabled: a,
              inputMode: "decimal",
              onBlur: (v) => {
                g?.(v), v.defaultPrevented || H();
              },
              onChange: (v) => P(v.currentTarget.value),
              onCompositionEnd: (v) => {
                Q.current = !1;
              },
              onCompositionStart: (v) => {
                Q.current = !0;
              },
              onFocus: (v) => {
                i && P(w(y)), j(!0), b?.(v);
              },
              onKeyDown: (v) => {
                if (_?.(v), !v.defaultPrevented) {
                  if ((v.key === "Enter" || v.key === "Escape") && Rt(v, Q.current)) {
                    v.stopPropagation();
                    return;
                  }
                  v.key === "ArrowUp" && (v.preventDefault(), I(l)), v.key === "ArrowDown" && (v.preventDefault(), I(-l)), v.key === "Enter" && (H(), v.currentTarget.blur()), v.key === "Escape" && (P(w(y)), j(!1), v.currentTarget.blur());
                }
              },
              ref: M,
              type: "text",
              value: !O && i ? i(y) : A
            }
          ),
          x && /* @__PURE__ */ t("span", { className: ct.unit, "data-openbitfun-part": "unit", children: x }),
          C && E !== "compact" && /* @__PURE__ */ k("span", { className: ct.buttons, "data-openbitfun-part": "buttons", children: [
            /* @__PURE__ */ t("button", { "aria-label": n, disabled: a || y <= d, onClick: () => I(-l), tabIndex: -1, type: "button", children: "−" }),
            /* @__PURE__ */ t("button", { "aria-label": s, disabled: a || y >= p, onClick: () => I(l), tabIndex: -1, type: "button", children: "+" })
          ] })
        ]
      }
    )
  ] });
}), Ti = "_root_1t0qc_2", qi = "_value_1t0qc_22", vn = {
  root: Ti,
  value: qi
}, Oi = T(function({
  className: e,
  value: n,
  ...a
}, r) {
  return /* @__PURE__ */ t(
    "span",
    {
      ...a,
      className: R(vn.root, e),
      "data-openbitfun-component": "number-badge",
      ref: r,
      children: /* @__PURE__ */ t("span", { className: vn.value, "data-openbitfun-part": "value", children: n })
    }
  );
}), Fi = "_root_14b7d_2", Vi = "_viewport_14b7d_3", Bi = "_list_14b7d_4", Hi = "_section_14b7d_5", Ki = "_heading_14b7d_6", ji = "_items_14b7d_7", Yi = "_separator_14b7d_8", Gi = "_headingLabel_14b7d_81", Wi = "_headingActions_14b7d_94", Ui = "_headingAction_14b7d_94", Xi = "_item_14b7d_7", Ee = {
  root: Fi,
  viewport: Vi,
  list: Bi,
  section: Hi,
  heading: Ki,
  items: ji,
  separator: Yi,
  headingLabel: Gi,
  headingActions: Wi,
  headingAction: Ui,
  item: Xi
};
function Ji(o, e) {
  typeof o == "function" ? o(e) : o && (o.current = e);
}
function jt(o) {
  return Array.from(
    o.querySelectorAll("[data-openbitfun-menu-item]")
  ).filter((e) => e.closest('[role="menu"]') === o && !e.disabled && e.getAttribute("aria-disabled") !== "true");
}
function At(o, e, n = !0) {
  const a = o[e];
  a && (o.forEach((r, i) => {
    r.tabIndex = i === e ? 0 : -1;
  }), n && (a.focus(), a.scrollIntoView?.({ block: "nearest", inline: "nearest" })));
}
const Qi = T(function({
  autoFocusFirstItem: e = !1,
  children: n,
  className: a,
  onFocusCapture: r,
  onKeyDown: i,
  scrollbarVisibility: s = "auto",
  ...c
}, p) {
  const d = Y({ node: null }), g = Y(!1), f = W((h) => {
    d.current.node = h, Ji(p, h);
  }, [p]);
  se(() => {
    const h = d.current.node;
    if (!h) return;
    e || (g.current = !1);
    const C = jt(h);
    if (C.length === 0) {
      e && !g.current && (g.current = !0, h.focus());
      return;
    }
    const m = Math.max(C.findIndex((l) => l.tabIndex === 0), 0);
    At(C, m, !1), e && !g.current && (g.current = !0, At(C, m));
  }, [e, n]);
  const b = (h) => {
    if (r?.(h), h.defaultPrevented) return;
    const C = h.target.closest ? h.target.closest("[data-openbitfun-menu-item]") : null;
    if (!C || !h.currentTarget.contains(C)) return;
    const m = jt(h.currentTarget), l = m.indexOf(C);
    l >= 0 && At(m, l, !1);
  }, _ = (h) => {
    if (i?.(h), h.defaultPrevented || Rt(h)) return;
    const C = h.target.closest ? h.target.closest("[data-openbitfun-menu-item]") : null;
    if (!C || !h.currentTarget.contains(C)) return;
    const m = jt(h.currentTarget), l = m.indexOf(C);
    if (l < 0 || m.length === 0) return;
    let x;
    switch (h.key) {
      case "ArrowDown":
        x = (l + 1) % m.length;
        break;
      case "ArrowUp":
        x = (l - 1 + m.length) % m.length;
        break;
      case "Home":
        x = 0;
        break;
      case "End":
        x = m.length - 1;
        break;
      default:
        if (h.key.length === 1 && !h.altKey && !h.ctrlKey && !h.metaKey) {
          const y = h.key.toLocaleLowerCase();
          for (let E = 1; E <= m.length; E += 1) {
            const $ = (l + E) % m.length;
            if ((m[$]?.textContent?.trim().toLocaleLowerCase() ?? "").startsWith(y)) {
              x = $;
              break;
            }
          }
        }
    }
    x !== void 0 && (h.preventDefault(), At(m, x));
  };
  return /* @__PURE__ */ t(
    "div",
    {
      ...c,
      className: R(Ee.root, a),
      "data-openbitfun-component": "menu",
      onFocusCapture: b,
      onKeyDown: _,
      ref: f,
      role: "menu",
      children: /* @__PURE__ */ t(
        an,
        {
          className: Ee.viewport,
          orientation: "vertical",
          scrollbarVisibility: s,
          children: /* @__PURE__ */ t("div", { className: Ee.list, "data-openbitfun-part": "list", children: n })
        }
      )
    }
  );
}), Zi = T(function({
  checked: e = !1,
  className: n,
  role: a = "menuitem",
  tabIndex: r = -1,
  ...i
}, s) {
  return /* @__PURE__ */ t(
    $n,
    {
      ...i,
      "aria-checked": a === "menuitem" ? void 0 : e,
      className: R(Ee.item, n),
      "data-openbitfun-menu-item": "",
      ref: s,
      role: a,
      tabIndex: r
    }
  );
}), Zl = T(function({
  "aria-label": e,
  "aria-labelledby": n,
  actions: a = [],
  children: r,
  className: i,
  title: s,
  ...c
}, p) {
  const d = Re(), g = s != null ? d : void 0;
  return /* @__PURE__ */ k(
    "div",
    {
      ...c,
      "aria-label": e,
      "aria-labelledby": e || n ? n : g,
      className: R(Ee.section, i),
      "data-openbitfun-part": "section",
      ref: p,
      role: "group",
      children: [
        g && /* @__PURE__ */ k("div", { className: Ee.heading, "data-openbitfun-part": "heading", id: g, children: [
          /* @__PURE__ */ t(ie, { className: Ee.headingLabel, "data-openbitfun-part": "heading-label", children: s }),
          a.length > 0 && /* @__PURE__ */ t("span", { className: Ee.headingActions, "data-openbitfun-part": "heading-actions", children: a.map((b) => /* @__PURE__ */ t(
            ve,
            {
              "aria-label": b.label,
              className: Ee.headingAction,
              "data-openbitfun-menu-item": "",
              disabled: b.disabled,
              icon: b.icon,
              onClick: b.onClick,
              size: "sm",
              role: "menuitem",
              tabIndex: -1,
              tone: b.tone,
              variant: "quiet"
            },
            b.id
          )) })
        ] }),
        /* @__PURE__ */ t("div", { className: Ee.items, "data-openbitfun-part": "section-items", children: r })
      ]
    }
  );
}), es = T(
  function({ className: e, ...n }, a) {
    return /* @__PURE__ */ t(
      "div",
      {
        ...n,
        className: R(Ee.separator, e),
        "data-openbitfun-part": "separator",
        ref: a,
        role: "separator"
      }
    );
  }
), ts = 120, ns = 300, as = 300, Sn = 48, os = 300, rs = 2, It = 4, on = (o, e) => e.right > e.left && e.bottom > e.top && o.x >= e.left && o.x <= e.right && o.y >= e.top && o.y <= e.bottom, is = (o, e, n) => {
  if (e.right <= e.left || e.bottom <= e.top || n.right <= n.left || n.bottom <= n.top)
    return !1;
  const a = n.left + n.right > e.left + e.right;
  return on(o, {
    left: (a ? e.right : n.right) - It,
    right: (a ? n.left : e.left) + It,
    top: n.top - It,
    bottom: n.bottom + It
  });
}, yn = (o, e) => {
  const n = Math.max(e.left - o.x, 0, o.x - e.right), a = Math.max(e.top - o.y, 0, o.y - e.bottom);
  return Math.hypot(n, a);
}, Yt = (o, e, n) => (o.x - n.x) * (e.y - n.y) - (e.x - n.x) * (o.y - n.y), ss = (o, e, n, a) => {
  const r = Yt(o, e, n), i = Yt(o, n, a), s = Yt(o, a, e), c = r < 0 || i < 0 || s < 0, p = r > 0 || i > 0 || s > 0;
  return !(c && p);
}, cs = (o, e, n, a = Sn) => {
  if (on(e, n)) return !0;
  const r = o.x <= n.left, i = o.x >= n.right;
  if (!r && !i) return !1;
  const s = r ? n.left : n.right, c = e.x - o.x;
  return r && c <= 0 || i && c >= 0 || yn(e, n) >= yn(o, n) ? !1 : ss(
    e,
    o,
    { x: s, y: n.top - a },
    { x: s, y: n.bottom + a }
  );
}, Gt = (o) => !o.pointerType || o.pointerType === "mouse", ls = ({
  activeId: o,
  onActiveIdChange: e,
  parentRef: n,
  submenuRef: a,
  enabled: r = !0,
  openDelayMs: i = ts,
  closeDelayMs: s = ns,
  switchDelayMs: c = as,
  tolerance: p = Sn
}) => {
  const d = Y(o), g = Y(e), f = Y([]), b = Y(null), _ = Y(null), h = Y(!1);
  d.current = o, g.current = e;
  const C = W(() => {
    const w = b.current;
    w && (window.clearTimeout(w.timer), b.current = null);
  }, []), m = W(() => {
    _.current !== null && (window.clearTimeout(_.current), _.current = null);
  }, []), l = W(() => {
    C(), m(), h.current = !1;
  }, [m, C]), x = W((w) => {
    l(), d.current = w, g.current(w);
  }, [l]), y = W((w, N, A) => {
    C();
    const P = window.setTimeout(() => {
      b.current = null, x(w);
    }, A);
    b.current = { targetId: w, kind: N, timer: P };
  }, [C, x]), E = W(() => {
    m(), _.current = window.setTimeout(() => {
      _.current = null, x(null);
    }, s);
  }, [m, s, x]), $ = W((w) => {
    for (let N = f.current.length - 1; N >= 0; N -= 1) {
      const A = f.current[N];
      if (!A) continue;
      const P = w.time - A.time, O = Math.hypot(w.x - A.x, w.y - A.y);
      if (P >= 0 && P <= os && O >= rs)
        return A;
    }
    return null;
  }, []), q = W((w, N) => {
    const A = a.current?.getBoundingClientRect();
    return !!(w && A && cs(w, N, A, p));
  }, [a, p]), z = W((w) => {
    if (d.current === null) return null;
    const N = a.current?.getBoundingClientRect();
    if (!N) return null;
    if (on(w, N)) return "submenu";
    const A = n.current?.getBoundingClientRect();
    return A && is(w, A, N) ? "bridge" : null;
  }, [n, a]), V = W((w, N) => {
    if (!r || !Gt(N)) return;
    m(), h.current = !1;
    const A = d.current;
    if (Object.is(A, w)) {
      C();
      return;
    }
    const P = {
      x: N.clientX,
      y: N.clientY,
      time: N.timeStamp
    }, O = $(P);
    if (A !== null && q(O, P)) {
      y(w, "switch", c);
      return;
    }
    if (A === null && w !== null && i > 0) {
      y(w, "open", i);
      return;
    }
    x(w);
  }, [
    m,
    C,
    x,
    r,
    $,
    i,
    q,
    y,
    c
  ]), F = W((w) => {
    if (!(!r || w && !Gt(w)) && (C(), d.current !== null)) {
      if (h.current = !0, w && z({ x: w.clientX, y: w.clientY })) {
        m();
        return;
      }
      E();
    }
  }, [m, C, r, z, E]), S = W(() => {
    l();
  }, [l]), M = W((w) => {
    x(w);
  }, [x]), L = W(() => {
    x(null);
  }, [x]);
  return se(() => {
    if (!r) {
      l(), f.current = [];
      return;
    }
    const w = (A) => {
      if (!Gt(A)) return;
      const P = {
        x: A.clientX,
        y: A.clientY,
        time: A.timeStamp
      }, O = $(P), j = z(P), Q = !j && d.current !== null && q(O, P), H = b.current;
      j ? (l(), h.current = j === "bridge") : H?.kind === "switch" ? Q ? y(H.targetId, "switch", c) : x(H.targetId) : h.current && (_.current === null || Q) && E(), f.current.push(P), f.current.length > 4 && f.current.shift();
    }, N = () => F();
    return document.addEventListener("pointermove", w, { capture: !0, passive: !0 }), document.addEventListener("pointerleave", N), window.addEventListener("blur", N), () => {
      document.removeEventListener("pointermove", w, !0), document.removeEventListener("pointerleave", N), window.removeEventListener("blur", N);
    };
  }, [
    l,
    x,
    r,
    $,
    z,
    q,
    F,
    E,
    y,
    c
  ]), se(() => l, [l]), {
    requestChange: V,
    requestClose: F,
    keepOpen: S,
    openNow: M,
    closeNow: L,
    cancelPending: l
  };
}, ds = "_icon_xflqh_3", us = "_submenuArrow_xflqh_4", ps = "_submenuBoundary_xflqh_19", fs = "_popup_xflqh_20", Lt = {
  icon: ds,
  submenuArrow: us,
  submenuBoundary: ps,
  popup: fs
};
function xn(o) {
  return Array.from(o.querySelectorAll("[data-openbitfun-menu-item]")).filter((e) => e.closest('[role="menu"]') === o && !e.disabled && e.getAttribute("aria-disabled") !== "true");
}
function ed({ items: o, open: e, onClose: n, anchorRef: a, position: r, placement: i = "bottom", autoFocusFirstItem: s = !0, ...c }) {
  const p = Y(null), d = Y(null), g = Re(), { present: f, state: b } = ra(e, 100), _ = a ?? p, h = a ? [a] : [], C = () => {
    a?.current?.isConnected && a.current.focus(), n();
  };
  en({
    branchRefs: h,
    containsTarget: (l) => l instanceof Element && l.closest("[data-openbitfun-menu-tree]")?.getAttribute("data-openbitfun-menu-tree") === g,
    enabled: e,
    layerRef: d,
    onDismiss: C
  }), ia({
    active: e && f,
    autoFocus: s,
    containerRef: d,
    restoreFocus: !a,
    trapFocus: !1
  });
  const m = f ? /* @__PURE__ */ t(
    Mn,
    {
      ...c,
      anchorRef: _,
      autoFocusFirstItem: !1,
      items: o,
      menuRef: d,
      onClose: C,
      open: e,
      phase: b,
      placement: i,
      position: r,
      treeId: g
    }
  ) : null;
  return /* @__PURE__ */ k(je, { children: [
    /* @__PURE__ */ t("span", { ref: p, hidden: !0 }),
    /* @__PURE__ */ t(Et, { ownerDocument: p.current?.ownerDocument, children: m })
  ] });
}
function Mn({ items: o, open: e, phase: n, treeId: a, onClose: r, onBack: i, anchorRef: s, position: c, placement: p, menuRef: d, autoFocusFirstItem: g, className: f, style: b, parts: _, ...h }) {
  const C = _?.root ?? Qi, m = _?.item ?? Zi, l = _?.separator ?? es, x = _?.icon ?? "span", y = _?.label ?? "span", E = _?.shortcut ?? "span", $ = _?.submenuArrow ?? "span", q = _?.submenu ?? "div", z = Y(null), V = d ?? z, F = Y(null), S = Y(null), M = Y(!1), [L, w] = ue(null), N = Re(), A = ls({ activeId: L, onActiveIdChange: w, parentRef: V, submenuRef: F, enabled: e, openDelayMs: 150, closeDelayMs: 300, switchDelayMs: 300, tolerance: 50 }), P = nn({ open: !0, anchorRef: s, layerRef: V, placement: p, point: c }), O = o.find((I) => I.id === L && !I.disabled && I.submenu?.length), j = (I, v, K) => {
    I.disabled || !I.submenu?.length || (S.current = v, M.current = K, A.openNow(I.id), L === I.id && F.current && xn(F.current)[0]?.focus());
  }, Q = (I) => {
    I.disabled || I.separator || (r(), I.onSelect?.());
  };
  se(() => {
    e || A.closeNow();
  }, [e, A.closeNow]), se(() => {
    if (!e) return;
    const I = V.current, v = I?.ownerDocument, K = (X) => {
      if (!I || v?.activeElement?.closest('[role="menu"]') !== I || Rt(X)) return;
      const oe = xn(I), ge = oe.indexOf(v.activeElement), _e = oe[ge], he = o.find((U) => U.id === _e?.getAttribute("data-menu-id"));
      let be;
      switch (X.key) {
        case "ArrowDown":
          be = (ge + 1) % oe.length;
          break;
        case "ArrowUp":
          be = (ge - 1 + oe.length) % oe.length;
          break;
        case "Home":
          be = 0;
          break;
        case "End":
          be = oe.length - 1;
          break;
        case "Tab":
          r();
          return;
        case "ArrowLeft":
          i && (X.preventDefault(), X.stopPropagation(), i());
          return;
        case "ArrowRight":
          he?.submenu?.length && _e && (X.preventDefault(), X.stopPropagation(), j(he, _e, !0));
          return;
        case "Enter":
        case " ":
          X.preventDefault(), X.stopPropagation(), he && _e && (he.submenu?.length ? j(he, _e, !0) : Q(he));
          return;
        default:
          if (X.key.length === 1 && !X.ctrlKey && !X.metaKey && !X.altKey)
            for (let U = 1; U <= oe.length; U++) {
              const ce = (ge + U) % oe.length;
              if (oe[ce]?.textContent?.trim().toLowerCase().startsWith(X.key.toLowerCase())) {
                be = ce;
                break;
              }
            }
      }
      be !== void 0 && (X.preventDefault(), X.stopPropagation(), oe[be]?.focus(), oe[be]?.scrollIntoView?.({ block: "nearest" }));
    };
    return v?.addEventListener("keydown", K, !0), () => v?.removeEventListener("keydown", K, !0);
  });
  const H = O ? /* @__PURE__ */ t(q, { className: Lt.submenuBoundary, children: /* @__PURE__ */ t(
    Mn,
    {
      id: N,
      "aria-label": O.label,
      menuRef: F,
      items: O.submenu,
      open: e,
      phase: n,
      treeId: a,
      onClose: r,
      parts: _,
      onBack: () => {
        A.closeNow(), S.current?.focus();
      },
      anchorRef: S,
      placement: "right",
      autoFocusFirstItem: M.current,
      onPointerEnter: A.keepOpen,
      onPointerLeave: A.requestClose
    },
    O.id
  ) }) : null;
  return /* @__PURE__ */ k(je, { children: [
    /* @__PURE__ */ t(
      C,
      {
        ...h,
        ref: (I) => {
          V.current = I;
        },
        className: R(Lt.popup, f),
        autoFocusFirstItem: e && g && !!P,
        tabIndex: -1,
        style: { ...P?.style, ...b, visibility: P ? void 0 : "hidden" },
        "data-openbitfun-native-webview-occlusion": !0,
        "data-openbitfun-menu-tree": a,
        "data-placement": P?.placement ?? p,
        "data-state": n,
        "aria-hidden": !e || void 0,
        ...e ? {} : { inert: "" },
        onContextMenu: (I) => I.preventDefault(),
        children: o.map((I) => I.separator ? /* @__PURE__ */ t(l, {}, I.id) : /* @__PURE__ */ t(
          m,
          {
            "data-menu-id": I.id,
            leading: I.icon ? /* @__PURE__ */ t(x, { className: Lt.icon, children: I.icon }) : void 0,
            shortcut: I.shortcut ? /* @__PURE__ */ t(E, { children: I.shortcut }) : void 0,
            tone: I.tone,
            role: I.role,
            checked: I.checked,
            disabled: I.disabled,
            "aria-disabled": I.disabled || void 0,
            "aria-haspopup": I.submenu?.length ? "menu" : void 0,
            "aria-expanded": I.submenu?.length ? O?.id === I.id : void 0,
            "aria-controls": O?.id === I.id ? N : void 0,
            metadata: I.submenu?.length ? /* @__PURE__ */ t($, { className: Lt.submenuArrow, children: /* @__PURE__ */ t(de, { name: "chevron-right", size: "sm" }) }) : void 0,
            onClick: (v) => {
              v.stopPropagation(), I.submenu?.length ? j(I, v.currentTarget, !0) : Q(I);
            },
            onPointerEnter: (v) => {
              (L === null || L === I.id) && (S.current = v.currentTarget), M.current = !1, A.requestChange(!I.disabled && I.submenu?.length ? I.id : null, v);
            },
            onPointerLeave: A.requestClose,
            ref: (v) => {
              O?.id === I.id && v && (S.current = v);
            },
            children: /* @__PURE__ */ t(y, { children: I.label })
          },
          I.id
        ))
      }
    ),
    H && /* @__PURE__ */ t(Et, { ownerDocument: V.current?.ownerDocument, children: H })
  ] });
}
const hs = "_root_2u5mw_2", bs = "_header_2u5mw_3", ms = "_body_2u5mw_4", gs = "_content_2u5mw_5", _s = "_section_2u5mw_6", vs = "_heading_2u5mw_7", ys = "_items_2u5mw_8", xs = "_separator_2u5mw_9", ws = "_footer_2u5mw_10", Ns = "_headingLabel_2u5mw_84", ks = "_headingActions_2u5mw_97", $s = "_headingAction_2u5mw_97", Cs = "_item_2u5mw_8", Ie = {
  root: hs,
  header: bs,
  body: ms,
  content: gs,
  section: _s,
  heading: vs,
  items: ys,
  separator: xs,
  footer: ws,
  headingLabel: Ns,
  headingActions: ks,
  headingAction: $s,
  item: Cs
}, td = T(
  function({
    children: e,
    className: n,
    ...a
  }, r) {
    return /* @__PURE__ */ t(
      "nav",
      {
        ...a,
        className: R(Ie.root, n),
        "data-openbitfun-component": "navigation-panel",
        ref: r,
        children: e
      }
    );
  }
), nd = T(
  function({ className: e, ...n }, a) {
    return /* @__PURE__ */ t(
      "div",
      {
        ...n,
        className: R(Ie.header, e),
        "data-openbitfun-part": "header",
        ref: a
      }
    );
  }
), ad = T(
  function({ className: e, scrollbarVisibility: n = "auto", ...a }, r) {
    return /* @__PURE__ */ t(
      an,
      {
        ...a,
        className: R(Ie.body, e),
        "data-openbitfun-part": "body",
        orientation: "vertical",
        ref: r,
        scrollbarVisibility: n
      }
    );
  }
), od = T(
  function({ className: e, ...n }, a) {
    return /* @__PURE__ */ t(
      "div",
      {
        ...n,
        className: R(Ie.content, e),
        "data-openbitfun-part": "content",
        ref: a
      }
    );
  }
), rd = T(
  function({ className: e, ...n }, a) {
    return /* @__PURE__ */ t(
      "div",
      {
        ...n,
        className: R(Ie.footer, e),
        "data-openbitfun-part": "footer",
        ref: a
      }
    );
  }
), id = T(
  function({
    "aria-current": e,
    className: n,
    selected: a = !1,
    ...r
  }, i) {
    return /* @__PURE__ */ t(
      $n,
      {
        ...r,
        "aria-current": e ?? (a ? "page" : void 0),
        className: R(Ie.item, n),
        ref: i
      }
    );
  }
), sd = T(
  function({
    "aria-label": e,
    "aria-labelledby": n,
    actions: a = [],
    children: r,
    className: i,
    title: s,
    ...c
  }, p) {
    const d = Re(), g = s != null ? d : void 0;
    return /* @__PURE__ */ k(
      "section",
      {
        ...c,
        "aria-label": e,
        "aria-labelledby": e || n ? n : g,
        className: R(Ie.section, i),
        "data-openbitfun-part": "section",
        ref: p,
        children: [
          g && /* @__PURE__ */ k("div", { className: Ie.heading, "data-openbitfun-part": "heading", id: g, children: [
            /* @__PURE__ */ t(ie, { className: Ie.headingLabel, "data-openbitfun-part": "heading-label", children: s }),
            a.length > 0 && /* @__PURE__ */ t("span", { className: Ie.headingActions, "data-openbitfun-part": "heading-actions", children: a.map((b) => /* @__PURE__ */ t(
              ve,
              {
                "aria-label": b.label,
                className: Ie.headingAction,
                disabled: b.disabled,
                icon: b.icon,
                onClick: b.onClick,
                size: "sm",
                tone: b.tone,
                variant: "quiet"
              },
              b.id
            )) })
          ] }),
          /* @__PURE__ */ t("div", { className: Ie.items, "data-openbitfun-part": "section-items", children: r })
        ]
      }
    );
  }
), cd = T(
  function({ className: e, ...n }, a) {
    return /* @__PURE__ */ t(
      "div",
      {
        ...n,
        className: R(Ie.separator, e),
        "data-openbitfun-part": "separator",
        ref: a,
        role: "separator"
      }
    );
  }
), As = "_root_1gme2_2", Is = "_leading_1gme2_15", Ls = "_content_1gme2_22", Ss = "_heading_1gme2_36", Ms = "_required_1gme2_70", Ps = "_description_1gme2_75", Ds = "_action_1gme2_105", at = {
  root: As,
  leading: Is,
  content: Ls,
  heading: Ss,
  required: Ms,
  description: Ps,
  action: Ds
}, ld = T(function({
  action: e,
  align: n = "start",
  className: a,
  description: r,
  leading: i,
  level: s = 1,
  required: c = !1,
  size: p = "md",
  title: d,
  ...g
}, f) {
  const b = `h${s}`;
  return /* @__PURE__ */ k(
    "div",
    {
      ...g,
      className: R(at.root, a),
      "data-align": n,
      "data-openbitfun-component": "page-header",
      "data-level": s,
      "data-required": c ? "true" : "false",
      "data-size": p,
      ref: f,
      children: [
        i != null && /* @__PURE__ */ t("span", { className: at.leading, "data-openbitfun-part": "leading", children: i }),
        /* @__PURE__ */ k("span", { className: at.content, "data-openbitfun-part": "content", children: [
          /* @__PURE__ */ k(b, { className: at.heading, "data-openbitfun-part": "heading", children: [
            d,
            c && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: at.required, "data-openbitfun-part": "required", children: "*" })
          ] }),
          r != null && /* @__PURE__ */ t("span", { className: at.description, "data-openbitfun-part": "description", children: r })
        ] }),
        e != null && /* @__PURE__ */ t("span", { className: at.action, "data-openbitfun-part": "action", children: e })
      ]
    }
  );
}), Es = "_root_1xcno_2", Rs = "_control_1xcno_16", zs = "_input_1xcno_26", Ts = "_circle_1xcno_37", qs = "_dot_1xcno_51", Os = "_content_1xcno_93", Fs = "_label_1xcno_100", Vs = "_description_1xcno_108", We = {
  root: Es,
  control: Rs,
  input: zs,
  circle: Ts,
  dot: qs,
  content: Os,
  label: Fs,
  description: Vs
}, dd = T(function({
  checked: e,
  children: n,
  className: a,
  defaultChecked: r,
  description: i,
  disabled: s = !1,
  invalid: c = !1,
  label: p,
  onChange: d,
  onCheckedChange: g,
  size: f = "md",
  ...b
}, _) {
  const h = p !== void 0 || i !== void 0 || n !== void 0;
  return /* @__PURE__ */ k(
    "label",
    {
      className: R(We.root, a),
      "data-openbitfun-component": "radio",
      "data-disabled": s ? "true" : "false",
      "data-invalid": c ? "true" : "false",
      "data-size": f,
      children: [
        /* @__PURE__ */ k("span", { className: We.control, "data-openbitfun-part": "control", children: [
          /* @__PURE__ */ t(
            "input",
            {
              ...b,
              "aria-invalid": c || void 0,
              checked: e,
              className: We.input,
              defaultChecked: r,
              disabled: s,
              onChange: (C) => {
                d?.(C), C.defaultPrevented || g?.(C.currentTarget.checked);
              },
              ref: _,
              type: "radio"
            }
          ),
          /* @__PURE__ */ t("span", { "aria-hidden": "true", className: We.circle, "data-openbitfun-part": "circle", children: /* @__PURE__ */ t("span", { className: We.dot }) })
        ] }),
        h && /* @__PURE__ */ k("span", { className: We.content, "data-openbitfun-part": "content", children: [
          p !== void 0 && /* @__PURE__ */ t("span", { className: We.label, children: p }),
          i !== void 0 && /* @__PURE__ */ t("span", { className: We.description, children: i }),
          n
        ] })
      ]
    }
  );
}), Pn = "(prefers-reduced-motion: reduce)";
function Bs(o) {
  const e = window.matchMedia?.(Pn);
  return e?.addEventListener("change", o), () => e?.removeEventListener("change", o);
}
function Hs() {
  return typeof window > "u" || !window.matchMedia ? !0 : window.matchMedia(Pn).matches;
}
function Ks() {
  return da(Bs, Hs, () => !0);
}
const js = "_root_11mhf_2", Ys = "_current_11mhf_14", Gs = "_outgoing_11mhf_18", Wt = {
  root: js,
  current: Ys,
  outgoing: Gs
}, wn = typeof window > "u" ? se : yt;
function Ws(o) {
  const e = Number.parseFloat(o);
  return Number.isFinite(e) ? e * (o.trim().endsWith("ms") ? 1 : 1e3) : 0;
}
function Us({ active: o, returning: e, revision: n, text: a, onComplete: r }) {
  const i = Y(null), s = Y(null), c = Y(null), p = Y(null), d = Y([]), g = Y(null);
  return wn(() => {
    const f = i.current, b = s.current, _ = c.current, h = f?.ownerDocument.defaultView;
    if (!f || !b || !h) return;
    const C = d.current.length > 0, m = C && g.current === n, l = C ? f.getBoundingClientRect().width : p.current, x = m ? h.getComputedStyle(b).transform : "translateY(100%)", y = m && _ ? h.getComputedStyle(_).transform : "translateY(0)", E = d.current;
    d.current = [], E.forEach((M) => M.cancel());
    const $ = f.getBoundingClientRect().width;
    if (p.current = $, !o || !_) return;
    const q = h.getComputedStyle(f), z = Ws(q.getPropertyValue("--_rolling-text-duration")), V = q.getPropertyValue("--_rolling-text-easing").trim();
    if (!f.animate || z <= 0 || $ <= 0) {
      r();
      return;
    }
    const F = { duration: z, easing: V, fill: "both" }, S = [
      b.animate([
        { transform: x },
        { transform: e ? "translateY(100%)" : "translateY(0)" }
      ], F),
      _.animate([
        { transform: y },
        { transform: e ? "translateY(0)" : "translateY(-100%)" }
      ], F),
      f.animate([
        { inlineSize: `${l ?? $}px` },
        { inlineSize: `${$}px` }
      ], F)
    ];
    d.current = S, g.current = n, Promise.all(S.map((M) => M.finished)).then(() => {
      d.current === S && r();
    }, () => {
    });
  }, [o, e, n, a, r]), wn(() => {
    const f = i.current, b = f && typeof ResizeObserver < "u" ? new ResizeObserver(() => {
      d.current.length === 0 && (p.current = f.getBoundingClientRect().width);
    }) : null;
    return f && b?.observe(f), () => {
      b?.disconnect();
      const _ = d.current;
      d.current = [], _.forEach((h) => h.cancel());
    };
  }, []), { rootRef: i, currentRef: s, outgoingRef: c };
}
const Xs = T(
  function({
    behavior: e = "marquee",
    children: n,
    className: a,
    marqueeActive: r,
    transitionKey: i = n,
    ...s
  }, c) {
    const p = Ks(), [d, g] = ue(() => ({
      identity: i,
      text: n,
      outgoing: null,
      revision: 0
    }));
    if (d.identity !== i || d.text !== n || p && d.outgoing !== null) {
      const m = !p && d.identity !== i && d.text !== n && d.outgoing === null;
      g({
        identity: i,
        text: n,
        outgoing: p ? null : m ? d.text : d.outgoing,
        revision: d.revision + (m ? 1 : 0)
      });
    }
    const f = d.outgoing !== null, b = W(() => {
      g((m) => m.revision === d.revision && m.outgoing !== null ? { ...m, outgoing: null } : m);
    }, [d.revision]), { rootRef: _, currentRef: h, outgoingRef: C } = Us({
      active: f,
      returning: d.text === d.outgoing,
      revision: d.revision,
      text: d.text,
      onComplete: b
    });
    return tn(c, () => _.current, [_]), /* @__PURE__ */ k(
      "span",
      {
        ...s,
        className: R(Wt.root, a),
        "data-openbitfun-component": "rolling-text",
        "data-transitioning": f ? "true" : "false",
        ref: _,
        children: [
          f && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Wt.outgoing, "data-rolling-text-part": "outgoing", ref: C, children: /* @__PURE__ */ t(ie, { behavior: "fade", children: d.outgoing }) }),
          /* @__PURE__ */ t(
            "span",
            {
              className: Wt.current,
              "data-rolling-text-part": "current",
              ref: h,
              children: /* @__PURE__ */ t(
                ie,
                {
                  behavior: f ? "fade" : e,
                  marqueeActive: r,
                  children: d.text
                }
              )
            },
            d.revision
          )
        ]
      }
    );
  }
), Js = "_root_zxm88_2", Qs = "_segment_zxm88_3", Zs = "_icon_zxm88_4", ec = "_label_zxm88_5", gt = {
  root: Js,
  segment: Qs,
  icon: Zs,
  label: ec
};
function Dn(o) {
  return o.find((e) => !e.disabled)?.value ?? "";
}
function tc(o, e) {
  const n = o.find((a) => a.value === e);
  return n && !n.disabled ? n.value : Dn(o);
}
const ud = T(
  function({
    className: e,
    defaultValue: n,
    interaction: a = "radio",
    labelBehavior: r = "overflow",
    disabled: i = !1,
    distribution: s = "content",
    onValueChange: c,
    options: p,
    size: d = "sm",
    tone: g = "accent",
    value: f,
    variant: b = "bar",
    ..._
  }, h) {
    const C = Y([]), [m, l] = ue(
      () => n ?? Dn(p)
    ), x = tc(p, f ?? m);
    function y($) {
      i || $.disabled || a === "radio" && $.value === x || (f === void 0 && l($.value), c?.($.value));
    }
    function E($, q) {
      const z = p.map((M, L) => ({ index: L, option: M })).filter(({ option: M }) => !M.disabled);
      if (z.length === 0)
        return;
      const V = z.findIndex(
        ({ index: M }) => M === q
      ), F = $.currentTarget.ownerDocument.defaultView?.getComputedStyle($.currentTarget).direction === "rtl";
      let S;
      if ($.key === "ArrowRight" || $.key === "ArrowLeft" || $.key === "ArrowDown" || $.key === "ArrowUp") {
        const L = $.key === "ArrowDown" || ($.key === "ArrowRight" ? !F : $.key === "ArrowLeft" && F) ? 1 : -1, w = (V + L + z.length) % z.length;
        S = z[w];
      } else if ($.key === "Home")
        S = z[0];
      else if ($.key === "End")
        S = z[z.length - 1];
      else
        return;
      S && ($.preventDefault(), y(S.option), C.current[S.index]?.focus());
    }
    return /* @__PURE__ */ t(
      "div",
      {
        ..._,
        "aria-disabled": i || void 0,
        className: R(gt.root, e),
        "data-openbitfun-component": "segmented-control",
        "data-openbitfun-part": "root",
        "data-disabled": i ? "true" : "false",
        "data-distribution": s,
        "data-size": d,
        "data-tone": g,
        "data-variant": b,
        ref: h,
        role: a === "radio" ? "radiogroup" : "group",
        "data-interaction": a,
        children: p.map(($, q) => {
          const z = $.value === x;
          return /* @__PURE__ */ k(
            "button",
            {
              "data-overflow-trigger": !0,
              "aria-checked": a === "radio" ? z : void 0,
              "aria-pressed": a === "buttons" ? z : void 0,
              className: gt.segment,
              "data-openbitfun-part": "segment",
              "data-openbitfun-value": $.value,
              disabled: i || $.disabled,
              onClick: () => y($),
              onKeyDown: a === "radio" ? (V) => E(V, q) : void 0,
              ref: (V) => {
                C.current[q] = V;
              },
              role: a === "radio" ? "radio" : void 0,
              tabIndex: a === "buttons" || z ? 0 : -1,
              type: "button",
              children: [
                $.icon && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: gt.icon, "data-openbitfun-part": "icon", children: $.icon }),
                r === "static" ? /* @__PURE__ */ t("span", { className: gt.label, "data-openbitfun-part": "label", children: $.label }) : /* @__PURE__ */ t(ie, { className: gt.label, "data-openbitfun-part": "label", children: $.label })
              ]
            },
            $.value
          );
        })
      }
    );
  }
), nc = "_root_ils27_2", ac = "_native_ils27_3", oc = "_trigger_ils27_4", rc = "_leading_ils27_5", ic = "_value_ils27_6", sc = "_placeholder_ils27_7", cc = "_indicator_ils27_8", lc = "_popover_ils27_9", dc = "_popoverHeader_ils27_10", uc = "_divider_ils27_11", pc = "_options_ils27_12", fc = "_listbox_ils27_233", Ce = {
  root: nc,
  native: ac,
  trigger: oc,
  leading: rc,
  value: ic,
  placeholder: sc,
  indicator: cc,
  popover: lc,
  popoverHeader: dc,
  divider: uc,
  options: pc,
  listbox: fc
}, hc = typeof window > "u" ? se : yt;
function bc(o, e) {
  typeof o == "function" ? o(e) : o && (o.current = e);
}
function mc(o) {
  return o === void 0 ? "" : String(o);
}
function lt(o, e) {
  return o === void 0 || e === void 0 ? o === e : String(o) === String(e);
}
function Ut(o, e, n) {
  return e !== void 0 ? e : n === void 0 ? o[0]?.value : void 0;
}
function gc(o) {
  const e = /* @__PURE__ */ new Map(), n = [];
  for (const a of o) {
    if (!a.group) {
      n.push(a);
      continue;
    }
    const r = e.get(a.group) ?? [];
    r.push(a), e.set(a.group, r);
  }
  return { groups: e, ungrouped: n };
}
function Nn(o) {
  return /* @__PURE__ */ t(
    "option",
    {
      "data-testid": o.testId,
      disabled: o.disabled,
      value: String(o.value),
      ...o.testAttributes,
      children: o.label
    },
    `${typeof o.value}:${o.value}`
  );
}
const pd = T(function({
  "aria-describedby": e,
  "aria-invalid": n,
  "aria-label": a,
  "aria-labelledby": r,
  "aria-required": i,
  autoFocus: s = !1,
  className: c,
  defaultOpen: p = !1,
  defaultValue: d,
  disabled: g = !1,
  id: f,
  invalid: b = !1,
  leading: _,
  onBlur: h,
  onFocus: C,
  onOpenChange: m,
  onValueChange: l,
  open: x,
  options: y,
  placement: E = "bottom",
  placeholder: $,
  required: q = !1,
  size: z = "md",
  style: V,
  tabIndex: F,
  title: S,
  value: M,
  ...L
}, w) {
  const N = Zt(), A = Dt(), P = Re(), O = f ?? `openbitfun-select-${P}`, j = `${O}-listbox`, Q = `${O}-native`, H = Y(null), I = Y(null), v = Y(null), K = Y(null), X = Y(!1), oe = De(() => [H], []), [ge, _e] = ue(p && !g), [he, be] = ue(() => Ut(y, d, $)), U = !g && (x ?? ge), ce = M !== void 0 ? M : he, me = b || n === !0 || n === "true", Ne = y.find((D) => lt(D.value, ce)), { groups: re, ungrouped: pe } = De(() => gc(y), [y]), Me = L["data-openbitfun-preview-state"], Je = W((D) => {
    v.current = D, bc(w, D);
  }, [w]), ke = W((D) => {
    D !== U && (x === void 0 && _e(D), m?.(D));
  }, [m, x, U]), $e = W((D) => {
    D && (X.current = !0), ke(!1);
  }, [ke]);
  hc(() => {
    U || !X.current || (X.current = !1, I.current?.isConnected && I.current.focus());
  }, [U]);
  const ze = W((D, G) => {
    g || D.disabled || (lt(D.value, ce) || (M === void 0 && be(D.value), l?.(D.value)), $e(G));
  }, [$e, g, l, ce, M]), Qe = (D) => {
    const G = y.find((ae) => String(ae.value) === D.currentTarget.value);
    G && ze(G, !1);
  }, Ye = (D) => {
    C?.(D), D.defaultPrevented || I.current?.focus();
  }, Ze = (D) => {
    if (!g) {
      if (D.key === "ArrowDown" || D.key === "ArrowUp") {
        if (D.preventDefault(), U) {
          const G = Array.from(
            K.current?.querySelectorAll(
              "[data-openbitfun-listbox-option]:not(:disabled)"
            ) ?? []
          ), ae = G.findIndex((ee) => ee.getAttribute("aria-selected") === "true"), fe = D.key === "ArrowUp" ? G.length - 1 : 0;
          G[ae >= 0 ? ae : fe]?.focus();
          return;
        }
        ke(!0);
        return;
      }
      if (D.key === "Enter" || D.key === " ") {
        D.preventDefault(), U ? $e(!0) : ke(!0);
        return;
      }
      if (!U && (D.key === "Home" || D.key === "End")) {
        const G = y.filter((fe) => !fe.disabled), ae = D.key === "Home" ? G[0] : G[G.length - 1];
        ae && (D.preventDefault(), ze(ae, !1));
        return;
      }
      if (!U && D.key.length === 1 && !D.altKey && !D.ctrlKey && !D.metaKey) {
        const G = y.filter((ee) => !ee.disabled), ae = G.findIndex((ee) => lt(ee.value, ce)), fe = D.key.toLocaleLowerCase();
        for (let ee = 1; ee <= G.length; ee += 1) {
          const Ve = G[(ae + ee) % G.length];
          if (Ve?.label.trim().toLocaleLowerCase().startsWith(fe)) {
            D.preventDefault(), ze(Ve, !1);
            break;
          }
        }
      }
    }
  }, Z = (D) => {
    if (D.key === "Tab") {
      $e(!0);
      return;
    }
    if (D.key !== "Enter" && D.key !== " ") return;
    const G = D.target instanceof Element ? D.target.closest("[data-openbitfun-listbox-option]") : null;
    !G || G.disabled || (D.preventDefault(), G.click());
  };
  en({
    branchRefs: oe,
    enabled: U,
    layerRef: K,
    onDismiss: (D) => $e(D === "escape-key"),
    ownerDocument: I.current?.ownerDocument
  });
  const te = nn({
    anchorRef: I,
    layerRef: K,
    matchWidth: !0,
    open: U,
    overlapAnchor: !0,
    placement: E,
    revision: y.length
  });
  se(() => {
    if (M !== void 0 || y.some((G) => lt(G.value, he))) return;
    const D = Ut(y, d, $);
    lt(D, he) || be(D);
  }, [d, y, $, he, M]), se(() => {
    const G = v.current?.form;
    if (!G || M !== void 0) return;
    const ae = () => {
      be(Ut(y, d, $)), ke(!1);
    };
    return G.addEventListener("reset", ae), () => G.removeEventListener("reset", ae);
  }, [d, y, $, ke, M]);
  const Te = (D) => /* @__PURE__ */ kn(
    Mt,
    {
      ...D.testAttributes,
      "aria-label": D.label,
      "data-testid": D.testId,
      disabled: D.disabled,
      key: `${typeof D.value}:${D.value}`,
      onClick: () => ze(D, !0),
      selected: lt(D.value, ce),
      value: D.value
    },
    D.label
  ), et = () => /* @__PURE__ */ k(je, { children: [
    _ != null && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Ce.leading, "data-openbitfun-part": "leading", children: _ }),
    /* @__PURE__ */ t(
      ie,
      {
        className: Ne ? Ce.value : Ce.placeholder,
        "data-openbitfun-part": "value",
        children: Ne?.label ?? $
      }
    ),
    /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Ce.indicator, "data-openbitfun-part": "indicator", children: /* @__PURE__ */ t(de, { name: "chevron-down", size: "sm" }) })
  ] }), Le = U ? /* @__PURE__ */ k(
    "div",
    {
      className: Ce.popover,
      "data-openbitfun-component": "select-popup",
      "data-openbitfun-part": "popover",
      "data-openbitfun-native-webview-occlusion": !0,
      "data-invalid": me ? "true" : "false",
      "data-placement": te?.placement ?? E,
      "data-size": z,
      ref: K,
      style: te?.style ?? { position: "fixed", visibility: "hidden" },
      children: [
        /* @__PURE__ */ t(
          "button",
          {
            "data-overflow-trigger": !0,
            "aria-controls": j,
            "aria-describedby": e,
            "aria-expanded": "true",
            "aria-haspopup": "listbox",
            "aria-invalid": b ? !0 : n,
            "aria-label": a,
            "aria-labelledby": r,
            "aria-required": q || i || void 0,
            className: R(Ce.trigger, Ce.popoverHeader),
            "data-openbitfun-part": "header",
            "data-openbitfun-preview-state": typeof Me == "string" ? Me : void 0,
            id: O,
            onClick: () => $e(!0),
            onKeyDown: Ze,
            role: "combobox",
            title: S,
            type: "button",
            children: et()
          }
        ),
        /* @__PURE__ */ t("div", { "aria-hidden": "true", className: Ce.divider, "data-openbitfun-part": "divider" }),
        /* @__PURE__ */ t("div", { className: Ce.options, "data-openbitfun-part": "options", children: /* @__PURE__ */ t(
          An,
          {
            "aria-label": a,
            "aria-labelledby": a ? void 0 : r ?? O,
            autoFocusOption: !0,
            className: Ce.listbox,
            id: j,
            onKeyDown: Z,
            children: y.length === 0 ? /* @__PURE__ */ t(Jt, { children: N.messages.noOptions }) : /* @__PURE__ */ k(je, { children: [
              pe.map(Te),
              [...re].map(([D, G]) => /* @__PURE__ */ t(In, { label: D, children: G.map(Te) }, D))
            ] })
          }
        ) })
      ]
    }
  ) : null;
  return /* @__PURE__ */ k(
    "span",
    {
      className: R(Ce.root, c),
      "data-openbitfun-component": "select",
      "data-disabled": g ? "true" : "false",
      "data-field-surface": A,
      "data-has-leading": _ != null ? "true" : "false",
      "data-invalid": me ? "true" : "false",
      "data-open": U ? "true" : "false",
      "data-placement": te?.placement ?? E,
      "data-size": z,
      ref: H,
      children: [
        /* @__PURE__ */ k(
          "select",
          {
            ...L,
            "aria-describedby": e,
            "aria-hidden": "true",
            "aria-invalid": b ? !0 : n,
            "aria-label": a,
            "aria-labelledby": r,
            "aria-required": q || i || void 0,
            className: Ce.native,
            disabled: g,
            id: Q,
            onBlur: h,
            onChange: Qe,
            onFocus: Ye,
            ref: Je,
            required: q,
            tabIndex: -1,
            value: mc(ce),
            children: [
              $ !== void 0 && /* @__PURE__ */ t("option", { disabled: !0, value: "", children: $ }),
              pe.map(Nn),
              [...re].map(([D, G]) => /* @__PURE__ */ t("optgroup", { label: D, children: G.map(Nn) }, D))
            ]
          }
        ),
        /* @__PURE__ */ t(
          "button",
          {
            "data-overflow-trigger": !0,
            "aria-controls": U ? void 0 : j,
            "aria-describedby": e,
            "aria-expanded": U ? void 0 : !1,
            "aria-hidden": U || void 0,
            "aria-haspopup": "listbox",
            "aria-invalid": b ? !0 : n,
            "aria-label": a,
            "aria-labelledby": r,
            "aria-required": q || i || void 0,
            autoFocus: !U && s,
            className: Ce.trigger,
            "data-openbitfun-part": "trigger",
            "data-openbitfun-preview-state": typeof Me == "string" ? Me : void 0,
            disabled: g,
            id: U ? void 0 : O,
            onClick: () => ke(!0),
            onKeyDown: Ze,
            ref: I,
            role: U ? void 0 : "combobox",
            style: V,
            tabIndex: U ? -1 : F,
            title: S,
            type: "button",
            children: et()
          }
        ),
        Le && /* @__PURE__ */ t(Et, { ownerDocument: I.current?.ownerDocument, children: Le })
      ]
    }
  );
}), _c = "_root_1kr03_2", vc = "_leading_1kr03_3", yc = "_label_1kr03_4", Xt = {
  root: _c,
  leading: vc,
  label: yc
}, fd = T(
  function({
    children: e,
    className: n,
    leading: a,
    tone: r = "success",
    emphasis: i = !1,
    ...s
  }, c) {
    return /* @__PURE__ */ k(
      "span",
      {
        ...s,
        className: R(Xt.root, n),
        "data-openbitfun-component": "status-pill",
        "data-tone": r,
        "data-emphasis": i ? "true" : "false",
        ref: c,
        children: [
          a != null && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Xt.leading, "data-openbitfun-part": "leading", children: a }),
          /* @__PURE__ */ t(ie, { className: Xt.label, "data-openbitfun-part": "label", children: e })
        ]
      }
    );
  }
), xc = "_root_11yh4_2", wc = "_loadingState_11yh4_3", Nc = "_cell_11yh4_4", kc = "_label_11yh4_5", Pt = {
  root: xc,
  loadingState: wc,
  cell: Nc,
  label: kc
}, $c = T(function({
  "aria-label": e,
  className: n,
  size: a = "md",
  variant: r = "matrix",
  ...i
}, s) {
  const c = r === "matrix" ? 9 : 3;
  return /* @__PURE__ */ t(
    "span",
    {
      ...i,
      "aria-hidden": e ? void 0 : "true",
      "aria-label": e,
      className: R(Pt.root, n),
      "data-openbitfun-component": "spinner",
      "data-size": a,
      "data-variant": r,
      ref: s,
      role: e ? "status" : void 0,
      children: Array.from({ length: c }, (p, d) => /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Pt.cell }, d))
    }
  );
}), hd = T(
  function({ children: e, className: n, size: a = "md", ...r }, i) {
    return /* @__PURE__ */ k(
      "div",
      {
        ...r,
        className: R(Pt.loadingState, n),
        "data-openbitfun-component": "loading-state",
        "data-size": a,
        ref: i,
        children: [
          /* @__PURE__ */ t($c, { size: a }),
          e ? /* @__PURE__ */ t("span", { className: Pt.label, "data-openbitfun-part": "label", children: e }) : null
        ]
      }
    );
  }
), Cc = "_input_1akar_11", Ac = "_track_1akar_22", Ic = "_thumb_1akar_34", St = {
  switch: "_switch_1akar_2",
  input: Cc,
  track: Ac,
  thumb: Ic
}, bd = T(function({
  className: e,
  onChange: n,
  onCheckedChange: a,
  ...r
}, i) {
  const s = (c) => {
    n?.(c), a?.(c.currentTarget.checked);
  };
  return /* @__PURE__ */ k(
    "span",
    {
      className: R(St.switch, e),
      "data-openbitfun-component": "switch",
      children: [
        /* @__PURE__ */ t(
          "input",
          {
            ...r,
            className: St.input,
            onChange: s,
            ref: i,
            role: "switch",
            type: "checkbox"
          }
        ),
        /* @__PURE__ */ t("span", { "aria-hidden": "true", className: St.track, children: /* @__PURE__ */ t("span", { className: St.thumb }) })
      ]
    }
  );
}), Lc = "_root_z7sr2_2", Sc = "_label_z7sr2_4", Mc = "_required_z7sr2_5", Pc = "_error_z7sr2_6", Dc = "_textarea_z7sr2_7", Ec = "_hint_z7sr2_37", Rc = "_count_z7sr2_37", zc = "_support_z7sr2_38", Ue = {
  root: Lc,
  label: Sc,
  required: Mc,
  error: Pc,
  textarea: Dc,
  hint: Ec,
  count: Rc,
  support: zc
}, Tc = typeof window > "u" ? se : yt, md = T(function({
  "aria-describedby": e,
  "aria-invalid": n,
  autoResize: a = !1,
  className: r,
  errorMessage: i,
  font: s = "sans",
  hint: c,
  id: p,
  invalid: d = !1,
  label: g,
  layout: f = "auto",
  maxLength: b,
  onChange: _,
  onCompositionEnd: h,
  onCompositionStart: C,
  onKeyDown: m,
  onValueChange: l,
  required: x,
  resize: y = "vertical",
  showCount: E = !1,
  value: $,
  variant: q = "default",
  ...z
}, V) {
  const F = Re(), S = Dt(), M = p ?? `${F}-textarea`, L = `${F}-support`, w = Y(!1), N = Y(null), [A, P] = ue(() => String(z.defaultValue ?? "").length), O = $ === void 0 ? A : String($).length, j = d || n !== void 0 && n !== !1 && n !== "false", Q = !!(j && i || !j && c || E), H = W((v) => {
    a && (v.style.height = "auto", v.style.height = `${v.scrollHeight}px`);
  }, [a]);
  tn(V, () => N.current), Tc(() => {
    N.current && H(N.current);
  }, [H, $]);
  const I = (v) => {
    P(v.currentTarget.value.length), H(v.currentTarget), _?.(v), l?.(v.currentTarget.value);
  };
  return /* @__PURE__ */ k(
    "span",
    {
      className: R(Ue.root, r),
      "data-auto-resize": a ? "true" : "false",
      "data-openbitfun-component": "textarea",
      "data-field-surface": S,
      "data-font": s,
      "data-invalid": j ? "true" : "false",
      "data-layout": f,
      "data-resize": y,
      "data-variant": q,
      children: [
        g && /* @__PURE__ */ k("label", { className: Ue.label, "data-openbitfun-part": "label", htmlFor: M, children: [
          g,
          x && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Ue.required, "data-openbitfun-part": "required", children: "*" })
        ] }),
        /* @__PURE__ */ t(
          "textarea",
          {
            ...z,
            "aria-describedby": Q ? L : e,
            "aria-invalid": j || void 0,
            className: Ue.textarea,
            "data-openbitfun-part": "input",
            id: M,
            maxLength: b,
            onChange: I,
            onCompositionEnd: (v) => {
              w.current = !1, h?.(v);
            },
            onCompositionStart: (v) => {
              w.current = !0, C?.(v);
            },
            onKeyDown: (v) => {
              if ((v.key === "Enter" || v.key === "Escape") && Rt(v, w.current)) {
                v.stopPropagation();
                return;
              }
              m?.(v);
            },
            ref: N,
            required: x,
            value: $
          }
        ),
        Q && /* @__PURE__ */ k("span", { className: Ue.support, "data-openbitfun-part": "support", id: L, children: [
          /* @__PURE__ */ t("span", { className: j ? Ue.error : Ue.hint, "data-openbitfun-part": "message", children: j ? i : c }),
          E && /* @__PURE__ */ k("span", { className: Ue.count, "data-openbitfun-part": "count", children: [
            O,
            b ? ` / ${b}` : ""
          ] })
        ] })
      ]
    }
  );
}), qc = "_native_1fp35_2", Oc = "_root_1fp35_6", Fc = "_header_1fp35_11", Vc = "_trigger_1fp35_29", Bc = "_indicator_1fp35_58", Hc = "_leading_1fp35_59", Kc = "_heading_1fp35_78", jc = "_summary_1fp35_85", Yc = "_description_1fp35_95", Gc = "_actions_1fp35_104", Wc = "_content_1fp35_112", Uc = "_contentInner_1fp35_130", Se = {
  native: qc,
  root: Oc,
  header: Fc,
  trigger: Vc,
  indicator: Bc,
  leading: Hc,
  heading: Kc,
  summary: jc,
  description: Yc,
  actions: Gc,
  content: Wc,
  contentInner: Uc
}, Xc = T(
  function({
    actions: e,
    renderHeader: n,
    contentClassName: a,
    contentInnerClassName: r,
    unmountOnClose: i = !1,
    exitDurationMs: s = 180,
    children: c,
    className: p,
    defaultOpen: d = !1,
    description: g,
    disabled: f = !1,
    leading: b,
    onOpenChange: _,
    open: h,
    presentation: C,
    summary: m,
    ...l
  }, x) {
    const y = Re(), E = `openbitfun-disclosure-${y}-trigger`, $ = `openbitfun-disclosure-${y}-content`, [q, z] = ue(d), V = h ?? q, F = V ? {} : { inert: "" }, [S, M] = ue(V);
    se(() => {
      if (V) {
        M(!0);
        return;
      }
      if (!S) return;
      const w = setTimeout(() => M(!1), Math.max(0, s));
      return () => clearTimeout(w);
    }, [V, S, s]);
    function L() {
      if (f) return;
      const w = !V;
      h === void 0 && z(w), _?.(w);
    }
    return /* @__PURE__ */ k(
      "section",
      {
        ...l,
        className: R(Se.root, p),
        "data-openbitfun-component": "disclosure",
        "data-disabled": f ? "true" : "false",
        "data-open": V ? "true" : "false",
        ref: x,
        children: [
          n ? n({
            "aria-controls": $,
            "aria-expanded": V,
            disabled: f,
            id: E,
            onClick: L,
            type: "button"
          }) : /* @__PURE__ */ k("div", { className: Se.header, "data-openbitfun-part": "header", children: [
            /* @__PURE__ */ k(
              "button",
              {
                "data-overflow-trigger": !0,
                "aria-controls": $,
                "aria-expanded": V,
                className: Se.trigger,
                disabled: f,
                id: E,
                onClick: L,
                type: "button",
                children: [
                  /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Se.indicator, "data-openbitfun-part": "indicator", children: /* @__PURE__ */ t(de, { name: "chevron-right", size: "sm" }) }),
                  b != null && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Se.leading, "data-openbitfun-part": "leading", children: b }),
                  /* @__PURE__ */ k("span", { className: Se.heading, "data-openbitfun-part": "heading", children: [
                    /* @__PURE__ */ t(ie, { className: Se.summary, "data-openbitfun-part": "summary", children: m }),
                    g != null && /* @__PURE__ */ t("span", { className: Se.description, "data-openbitfun-part": "description", children: g })
                  ] })
                ]
              }
            ),
            e != null && /* @__PURE__ */ t("span", { className: Se.actions, "data-openbitfun-part": "actions", children: e })
          ] }),
          (!i || V || S) && /* @__PURE__ */ t(
            "div",
            {
              ...F,
              "aria-hidden": !V,
              "aria-labelledby": E,
              className: R(Se.content, a),
              "data-open": V ? "true" : "false",
              "data-openbitfun-part": "content",
              id: $,
              role: "region",
              children: /* @__PURE__ */ t("div", { className: R(Se.contentInner, r), "data-openbitfun-part": "content-inner", children: c })
            }
          )
        ]
      }
    );
  }
), gd = T(
  function(e, n) {
    if (e.presentation === "native") {
      const { children: a, className: r, presentation: i, summary: s, ...c } = e;
      return /* @__PURE__ */ k(
        "details",
        {
          ...c,
          className: R(Se.native, r),
          "data-openbitfun-component": "disclosure",
          "data-presentation": i,
          ref: (p) => {
            typeof n == "function" ? n(p) : n && (n.current = p);
          },
          children: [
            /* @__PURE__ */ t("summary", { "data-openbitfun-part": "summary", children: s }),
            a
          ]
        }
      );
    }
    return /* @__PURE__ */ t(Xc, { ...e, ref: n });
  }
), Jc = "_root_ovmnz_2", Qc = "_media_ovmnz_14", Zc = "_title_ovmnz_40", el = "_description_ovmnz_49", tl = "_actions_ovmnz_59", _t = {
  root: Jc,
  media: Qc,
  title: Zc,
  description: el,
  actions: tl
}, _d = T(function({
  actions: e,
  children: n,
  className: a,
  description: r,
  icon: i,
  image: s,
  imageSize: c = "md",
  style: p,
  title: d,
  ...g
}, f) {
  const b = i ?? s ?? /* @__PURE__ */ t(de, { name: "folder", size: "lg", tone: "muted" }), _ = e ?? n;
  return /* @__PURE__ */ k(
    "div",
    {
      ...g,
      className: R(_t.root, a),
      "data-openbitfun-component": "empty",
      ref: f,
      style: p,
      children: [
        /* @__PURE__ */ t(
          "div",
          {
            className: _t.media,
            "data-openbitfun-part": "media",
            "data-size": c,
            children: b
          }
        ),
        d != null && /* @__PURE__ */ t("div", { className: _t.title, "data-openbitfun-part": "title", children: d }),
        r != null && /* @__PURE__ */ t("div", { className: _t.description, "data-openbitfun-part": "description", children: r }),
        _ != null && /* @__PURE__ */ t("div", { className: _t.actions, "data-openbitfun-part": "actions", children: _ })
      ]
    }
  );
}), nl = "_tabGroup_qvbex_2", al = "_item_qvbex_27", ol = "_tab_qvbex_2", rl = "_icon_qvbex_109", il = "_label_qvbex_128", sl = "_endAction_qvbex_134", cl = "_labelSuffix_qvbex_148", Xe = {
  tabGroup: nl,
  item: al,
  tab: ol,
  icon: rl,
  label: il,
  endAction: sl,
  labelSuffix: cl
};
function En(o) {
  return o.find((e) => !e.disabled)?.value ?? "";
}
function ll(o, e) {
  const n = o.find((a) => a.value === e);
  return n && !n.disabled ? n.value : En(o);
}
const vd = T(function({
  className: e,
  defaultValue: n,
  items: a,
  onValueChange: r,
  renderItem: i,
  size: s = "md",
  value: c,
  ...p
}, d) {
  const g = Re(), f = Y([]), [b, _] = ue(
    () => n ?? En(a)
  ), h = ll(a, c ?? b);
  function C(l) {
    l.disabled || l.value === h || (c === void 0 && _(l.value), r?.(l.value));
  }
  function m(l, x) {
    const y = a.map((z, V) => ({ index: V, item: z })).filter(({ item: z }) => !z.disabled);
    if (y.length === 0)
      return;
    const E = y.findIndex(({ index: z }) => z === x), $ = l.currentTarget.ownerDocument.defaultView?.getComputedStyle(l.currentTarget).direction === "rtl";
    let q;
    if (l.key === "ArrowRight" || l.key === "ArrowLeft") {
      const V = (l.key === "ArrowRight" ? !$ : $) ? 1 : -1, F = (E + V + y.length) % y.length;
      q = y[F];
    } else if (l.key === "Home")
      q = y[0];
    else if (l.key === "End")
      q = y[y.length - 1];
    else
      return;
    q && (l.preventDefault(), C(q.item), f.current[q.index]?.focus());
  }
  return /* @__PURE__ */ t(
    "div",
    {
      ...p,
      "aria-orientation": "horizontal",
      className: R(Xe.tabGroup, e),
      "data-openbitfun-component": "tab-group",
      "data-openbitfun-part": "root",
      "data-size": s,
      ref: d,
      role: "tablist",
      children: a.map((l, x) => {
        const y = l.value === h, E = l.endAction !== void 0 && l.endAction !== null, $ = !!l.icon, q = /* @__PURE__ */ k(
          "div",
          {
            className: Xe.item,
            "data-openbitfun-part": "item",
            "data-overflow-trigger": !0,
            "data-has-end-action": E ? "true" : "false",
            "data-has-icon": $ ? "true" : "false",
            children: [
              /* @__PURE__ */ k(
                "button",
                {
                  ...l.tabProps,
                  "aria-controls": l.panelId,
                  "aria-disabled": l.disabled || void 0,
                  "aria-selected": y,
                  className: R(Xe.tab, l.tabProps?.className),
                  "data-openbitfun-part": "tab",
                  "data-openbitfun-value": l.value,
                  disabled: l.disabled,
                  id: l.id ?? `${g}-tab-${x}`,
                  onClick: () => C(l),
                  onKeyDown: (z) => m(z, x),
                  ref: (z) => {
                    f.current[x] = z;
                  },
                  role: "tab",
                  tabIndex: y ? 0 : -1,
                  type: "button",
                  children: [
                    $ && /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Xe.icon, "data-openbitfun-part": "icon", children: l.icon }),
                    l.labelTransitionKey !== void 0 && (typeof l.label == "string" || typeof l.label == "number") ? /* @__PURE__ */ t(
                      Xs,
                      {
                        className: Xe.label,
                        "data-openbitfun-part": "label",
                        transitionKey: l.labelTransitionKey,
                        children: l.label
                      }
                    ) : /* @__PURE__ */ t(ie, { behavior: "marquee", className: Xe.label, "data-openbitfun-part": "label", children: l.label }),
                    l.labelSuffix != null && /* @__PURE__ */ t("span", { className: Xe.labelSuffix, "data-openbitfun-part": "labelSuffix", children: l.labelSuffix })
                  ]
                }
              ),
              E && /* @__PURE__ */ t("span", { className: Xe.endAction, "data-openbitfun-part": "endAction", children: l.endAction })
            ]
          },
          l.value
        );
        return /* @__PURE__ */ t(ua, { children: i ? i(l, q, x) : q }, l.value);
      })
    }
  );
}), dl = "_root_ueinv_2", ul = "_leading_ueinv_3", pl = "_center_ueinv_4", fl = "_trailing_ueinv_5", hl = "_group_ueinv_6", bl = "_separator_ueinv_7", ml = "_badge_ueinv_121", rt = {
  root: dl,
  leading: ul,
  center: pl,
  trailing: fl,
  group: hl,
  separator: bl,
  badge: ml
}, yd = T(function({
  bordered: e = !0,
  center: n,
  className: a,
  leading: r,
  leadingOverflow: i = "visible",
  size: s = "sm",
  trailing: c,
  ...p
}, d) {
  const g = n != null;
  return /* @__PURE__ */ k(
    "div",
    {
      ...p,
      className: R(rt.root, a),
      "data-openbitfun-component": "toolbar",
      "data-bordered": e ? "true" : "false",
      "data-has-center": g ? "true" : "false",
      "data-size": s,
      ref: d,
      children: [
        r != null && /* @__PURE__ */ t(
          "div",
          {
            className: rt.leading,
            "data-openbitfun-part": "leading",
            "data-overflow": i,
            children: r
          }
        ),
        g && /* @__PURE__ */ t("div", { className: rt.center, "data-openbitfun-part": "center", children: n }),
        c != null && /* @__PURE__ */ t("div", { className: rt.trailing, "data-openbitfun-part": "trailing", children: c })
      ]
    }
  );
}), xd = T(
  function({ children: e, className: n, gap: a = "sm", ...r }, i) {
    return /* @__PURE__ */ t(
      "div",
      {
        ...r,
        className: R(rt.group, n),
        "data-openbitfun-part": "group",
        "data-gap": a,
        ref: i,
        children: e
      }
    );
  }
), wd = T(
  function({ children: e, className: n, ...a }, r) {
    return /* @__PURE__ */ t(Oi, { ...a, className: R(rt.badge, n), "data-openbitfun-part": "badge", ref: r, value: e });
  }
), Nd = T(
  function({ className: e, ...n }, a) {
    return /* @__PURE__ */ t(
      "span",
      {
        ...n,
        "aria-hidden": "true",
        className: R(rt.separator, e),
        "data-openbitfun-part": "separator",
        ref: a
      }
    );
  }
), kd = T(function({
  height: e,
  size: n = 24,
  width: a,
  style: r,
  ...i
}, s) {
  return /* @__PURE__ */ t(
    sa,
    {
      ...i,
      ref: s,
      width: a ?? n,
      height: e ?? n,
      strokeWidth: 1.6,
      style: { opacity: "var(--openbitfun-opacity-icon-artwork)", ...r }
    }
  );
}), gl = "_stack_1rzex_2", _l = {
  stack: gl
}, vl = {
  0: "var(--openbitfun-space-0)",
  1: "var(--openbitfun-space-1)",
  2: "var(--openbitfun-space-2)",
  3: "var(--openbitfun-space-3)",
  4: "var(--openbitfun-space-4)",
  5: "var(--openbitfun-space-5)",
  6: "var(--openbitfun-space-6)",
  8: "var(--openbitfun-space-8)",
  10: "var(--openbitfun-space-10)",
  12: "var(--openbitfun-space-12)"
};
function $d({
  align: o = "stretch",
  className: e,
  direction: n = "vertical",
  gap: a = "3",
  justify: r = "start",
  style: i,
  wrap: s = !1,
  ...c
}) {
  const p = {
    ...i,
    "--_stack-gap": vl[a]
  };
  return /* @__PURE__ */ t(
    "div",
    {
      ...c,
      className: R(_l.stack, e),
      "data-align": o,
      "data-direction": n,
      "data-justify": r,
      "data-wrap": s ? "true" : "false",
      style: p
    }
  );
}
const yl = "_root_16c43_2", xl = {
  root: yl
};
function Cd({
  children: o,
  className: e,
  colorScheme: n = "light",
  contrast: a = "standard",
  density: r = "comfortable",
  style: i,
  tokenOverrides: s,
  ...c
}) {
  const p = {
    ...i,
    ...s
  };
  return /* @__PURE__ */ t(
    "div",
    {
      ...c,
      className: R(xl.root, e),
      "data-openbitfun-design-system-root": "",
      "data-color-scheme": n,
      "data-contrast": a,
      "data-density": r,
      style: p,
      children: o
    }
  );
}
export {
  Il as ActionCard,
  $n as ActionItem,
  Ll as ActivityItem,
  Ml as Alert,
  Ao as Avatar,
  Pl as AvatarGroup,
  Ft as Button,
  El as Card,
  zl as CardBody,
  ql as CardFooter,
  Rl as CardHeader,
  Tl as CardMedia,
  Sl as ChangeCount,
  Dl as Checkbox,
  Hl as Combobox,
  Ol as Composer,
  Fl as ComposerContextBar,
  Bl as ComposerDivider,
  Vl as ComposerToolbar,
  jl as ConfirmDialog,
  Al as DesignSystemProvider,
  Un as Dialog,
  ea as DialogBody,
  Zn as DialogClose,
  Ld as DialogDescription,
  ta as DialogFooter,
  Xn as DialogHeader,
  Sd as DialogHeaderActions,
  Jn as DialogHeading,
  Qn as DialogTitle,
  gd as Disclosure,
  _d as Empty,
  Yl as Field,
  Wl as FieldGroup,
  Ul as FieldRow,
  Gl as FormSection,
  de as Icon,
  ve as IconButton,
  Gn as Input,
  Xl as KeyHint,
  Jl as LauncherButton,
  An as Listbox,
  Jt as ListboxEmpty,
  In as ListboxGroup,
  Mt as ListboxOption,
  hd as LoadingState,
  Qi as Menu,
  Zi as MenuItem,
  ed as MenuPopover,
  Zl as MenuSection,
  es as MenuSeparator,
  Kl as MultiSelect,
  td as NavigationPanel,
  ad as NavigationPanelBody,
  od as NavigationPanelContent,
  rd as NavigationPanelFooter,
  nd as NavigationPanelHeader,
  id as NavigationPanelItem,
  sd as NavigationPanelSection,
  cd as NavigationPanelSeparator,
  Oi as NumberBadge,
  Ql as NumberInput,
  ie as OverflowText,
  ld as PageHeader,
  dd as Radio,
  Xs as RollingText,
  an as ScrollArea,
  Cr as SearchField,
  ud as SegmentedControl,
  pd as Select,
  kd as SessionIcon,
  Md as Sheet,
  $c as Spinner,
  $d as Stack,
  fd as StatusPill,
  bd as Switch,
  vd as TabGroup,
  md as Textarea,
  Cd as ThemeRoot,
  yd as Toolbar,
  wd as ToolbarBadge,
  xd as ToolbarGroup,
  Nd as ToolbarSeparator,
  pt as Tooltip,
  Cl as VoiceCallPanel,
  $a as VoiceParticleLogo,
  Pd as canonicalIconNames,
  Dd as iconAliases,
  Ed as iconNames,
  is as isPointInSubmenuBridge,
  cs as isPointerMovingTowardSubmenu,
  en as useDismissibleLayer,
  Rd as useHasOverlayLayers,
  zd as useOverlayLayerActions,
  ls as useSubmenuIntent
};
//# sourceMappingURL=index.js.map
